<div class="decision-role-container">
    <!-- <p class="page-heading d-flex justify-content-center">Decision Role</p>
    <hr /> -->
    <div class="container-body">
        <p-tabView class="custom-tabview">

            <!-- ================= TAB 1: License & Endorsements ================= -->
            <p-tabPanel *ngIf="intakerole == true && !isNoCommentsAvailable">
                <ng-template pTemplate="header">
                    <div class="tab-header">
                        <i class="pi pi-briefcase"></i>
                        <span>Deficiency Builder</span>
                    </div>
                </ng-template>
                <p-accordion class="custom-accordion" [activeIndex]="0">

                    <p-accordionTab [header]="'Internal Notes'">
                        <div class="deficiencynotes-table-container decisionactionsgrid">

                                                         <dx-data-grid #dataGrid [dataSource]="internalCommentsData" [showBorders]="true"
                            [rowAlternationEnabled]="true" [columnAutoWidth]="true" [wordWrapEnabled]="isWordWrapEnabled"
                            [allowColumnResizing]="true" [columnResizingMode]="'widget'"
                            (onContentReady)="setActionColumnWidth($event)">

                            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
                            <dxo-header-filter [visible]="false"></dxo-header-filter>
                            <dxo-paging [pageSize]="10"></dxo-paging>
                            <dxo-pager [visible]="true" [allowedPageSizes]="[10, 25, 50, 100]" [displayMode]="displayMode"
                            [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
                            <dxo-sorting mode="multiple"></dxo-sorting>

                            <ng-container *ngFor="let column of intcmntsgridConfig; let i = index">
                                <ng-container *ngIf="column.hide !== true">
                                    <ng-container *ngIf="column.link; else noLink">
                                        <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                            [allowFiltering]="column.filter" cellTemplate="cellTemplate"></dxi-column>
                                    </ng-container>
                                    <ng-template #noLink>
                                        <ng-container *ngIf="column.icon; else noIcon">
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter"
                                                cellTemplate="iconTemplate"></dxi-column>
                                        </ng-container>
                                    </ng-template>
                                    <ng-template #noIcon>
                                        <ng-container *ngIf="column.dateFormat; else noDate">
                                            <dxi-column
                                                *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                                                [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter" [dataType]="'date'"
                                                format="MM/dd/yyyy">
                                            </dxi-column>
                                        </ng-container>
                                    </ng-template>
                                    <ng-template #noDate>
                                        <ng-container *ngIf="column.isHtml; else noNotes">
                                    <dxi-column [dataField]="column.columnDef" [caption]="column.header" [allowFiltering]="column.filter" cellTemplate="htmlCellTemplate" [cssClass]="'max-width-col-2'"></dxi-column>
                                    </ng-container>
                                    </ng-template>
                                    <ng-template #noNotes>
                                        <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                            [allowFiltering]="column.filter">
                                        </dxi-column>
                                    </ng-template>
                                </ng-container>
                            </ng-container>
                            <dxi-column *ngIf="isVisible || isActionVisible" caption="Actions"
                                [width]="actionColumnWidth" [allowSorting]="false"
                                cellTemplate="actionsTemplate"></dxi-column>

                            <div *dxTemplate="let data of 'actionsTemplate'" class="licenseactioncontainer">
                                <button class="fa fa-edit action-icon-button" [disabled]="isViewMode"
                                    [ngStyle]="{ 'display': (isShowEdit === true) ? 'inline-block' : 'none' }"
                                    pTooltip="Edit" tooltipPosition="top"  tooltipStyleClass="pcustom-tooltip" (click)="ondefcmntEdit(data,'Edit Notes')">
                                    <span class="sr-only">Edit</span>
                                </button>
                                <button class="fa fa-eye action-icon-button" [disabled]="isViewMode"
                                    [ngStyle]="{ 'display': (isShowView === true) ? 'inline-block' : 'none' }"
                                    pTooltip="View" tooltipPosition="top" (click)="onView(data)">
                                    <span class="sr-only">View</span>
                                </button>
                                <button class="fa fa-trash ml-3 action-icon-button deletebtn" pTooltip="Delete" [disabled]="isViewMode"
                                    tooltipPosition="top"  tooltipStyleClass="pcustom-tooltip" (click)="onNoteDelete(data, noteDeleteModel)">
                                    <span class="sr-only">Delete</span>
                                </button>
                                <!-- <button class="fa fa-trash action-icon-button deletebtn"
                                [ngStyle]="{ 'display': (isShowDelete === true) ? 'inline-block' : 'none' }"
                                pTooltip="Delete" tooltipPosition="bottom" (click)="onLicRequirementDelete(data, deleteModel)">
                                <span class="sr-only">Delete</span>
                            </button> -->

                            </div>
                            <div *dxTemplate="let d of 'htmlCellTemplate'">
                                <span *ngIf="containsHtml(d.value)">{{ d.value | stripHtml }}</span>
                                <span *ngIf="!containsHtml(d.value)">{{ d.value }}</span>
                            </div>
                            <div *dxTemplate="let d of 'cellTemplate'">
                                <span href="javascript:void(0)" *ngIf="d.value && d.value !== 'null'" class="link-data"
                                    (click)="getRouter(d)">{{
                                    d.value !== 'null' ? d.value : ''
                                    }}</span>
                            </div>
                            <ng-container>
                                <div *dxTemplate="let d of 'cellTemplate'">
                                    <span *ngIf="d.value && d.value !== 'null'" #contentWrapper
                                        [innerHTML]="d.value | safeHtml">{{
                                        d.value !== 'null' ? d.value : ''
                                        }}</span>
                                </div>
                            </ng-container>
                            <div *dxTemplate="let d of 'iconTemplate'">
                                <em class="fa fa-book"></em>
                            </div>
                        </dx-data-grid>
                        </div>
                    </p-accordionTab>

                    <p-accordionTab [header]="'External Deficiency Comments'">
                            <div class="decisionactionsgrid deficiencynotes-table-container">

                        <dx-data-grid #dataGrid [dataSource]="deficiencyCommentsData" [showBorders]="true"
                            [rowAlternationEnabled]="true" [columnAutoWidth]="true" [wordWrapEnabled]="isWordWrapEnabled"
                            [allowColumnResizing]="true" [columnResizingMode]="'widget'"
                            (onContentReady)="setActionColumnWidth($event)">

                            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
                            <dxo-header-filter [visible]="false"></dxo-header-filter>
                            <dxo-paging [pageSize]="10"></dxo-paging>
                               <dxo-pager [visible]="true" [allowedPageSizes]="[10, 25, 50, 100]" [displayMode]="displayMode"
                            [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
                            <dxo-sorting mode="multiple"></dxo-sorting>

                            <ng-container *ngFor="let column of defcmntsgridConfig; let i = index">
                                <ng-container *ngIf="column.hide !== true">
                                    <ng-container *ngIf="column.link; else noLink">
                                        <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                            [allowFiltering]="column.filter" cellTemplate="cellTemplate"></dxi-column>
                                    </ng-container>
                                    <ng-template #noLink>
                                        <ng-container *ngIf="column.icon; else noIcon">
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter"
                                                cellTemplate="iconTemplate"></dxi-column>
                                        </ng-container>
                                    </ng-template>
                                    <ng-template #noIcon>
                                        <ng-container *ngIf="column.dateFormat; else noDate">
                                            <dxi-column
                                                *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                                                [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter" [dataType]="'date'"
                                                format="MM/dd/yyyy">
                                            </dxi-column>
                                        </ng-container>
                                    </ng-template>
                                    <ng-template #noDate>
                                        <ng-container *ngIf="column.isHtml; else noNotes">
                                    <dxi-column [dataField]="column.columnDef" [caption]="column.header" [allowFiltering]="column.filter" cellTemplate="htmlCellTemplate" [cssClass]="'max-width-col-2'"></dxi-column>
                                    </ng-container>
                                    </ng-template>
                                    <ng-template #noNotes>
                                        <dxi-column [dataField]="column.columnDef" [caption]="column.header" [cssClass]="'max-width-col-2'"
                                            [allowFiltering]="column.filter">
                                        </dxi-column>
                                    </ng-template>
                                </ng-container>
                            </ng-container>
                            <dxi-column *ngIf="isVisible || isActionVisible" caption="Actions"
                                [width]="actionColumnWidth" [allowSorting]="false"
                                cellTemplate="actionsTemplate"></dxi-column>

                            <div *dxTemplate="let data of 'actionsTemplate'" class="licenseactioncontainer">
                                <button class="fa fa-edit action-icon-button" [disabled]="isViewMode"
                                    [ngStyle]="{ 'display': (isShowEdit === true) ? 'inline-block' : 'none' }"
                                    pTooltip="Edit" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                    (click)="ondefcmntEdit(data,'Edit Deficiency Comments')">
                                    <span class="sr-only">Edit</span>
                                </button>
                                <button class="fa fa-eye action-icon-button" [disabled]="isViewMode"
                                    [ngStyle]="{ 'display': (isShowView === true) ? 'inline-block' : 'none' }"
                                    pTooltip="View" tooltipPosition="top"  tooltipStyleClass="pcustom-tooltip" (click)="onView(data)">
                                    <span class="sr-only">View</span>
                                </button>
                                <button class="fa fa-trash ml-3 action-icon-button deletebtn" pTooltip="Delete" [disabled]="isViewMode"
                                    tooltipPosition="top"  tooltipStyleClass="pcustom-tooltip" (click)="onNoteDelete(data, noteDeleteModel)">
                                    <span class="sr-only">Delete</span>
                                </button>
                                <!-- <button class="fa fa-trash action-icon-button deletebtn"
                                [ngStyle]="{ 'display': (isShowDelete === true) ? 'inline-block' : 'none' }"
                                pTooltip="Delete" tooltipPosition="bottom" (click)="onLicRequirementDelete(data, deleteModel)">
                                <span class="sr-only">Delete</span>
                            </button> -->

                            </div>
                             <div *dxTemplate="let d of 'htmlCellTemplate'">
                                <span *ngIf="containsHtml(d.value)">{{ d.value | stripHtml }}</span>
                                <span *ngIf="!containsHtml(d.value)">{{ d.value }}</span>
                            </div>
                            <div *dxTemplate="let d of 'cellTemplate'">
                                <span href="javascript:void(0)" *ngIf="d.value && d.value !== 'null'" class="link-data"
                                    (click)="getRouter(d)">{{
                                    d.value !== 'null' ? d.value : ''
                                    }}</span>
                            </div>
                            <ng-container>
                                <div *dxTemplate="let d of 'cellTemplate'">
                                    <span *ngIf="d.value && d.value !== 'null'" #contentWrapper
                                        [innerHTML]="d.value | safeHtml">{{
                                        d.value !== 'null' ? d.value : ''
                                        }}</span>
                                </div>
                            </ng-container>
                            <div *dxTemplate="let d of 'iconTemplate'">
                                <em class="fa fa-book"></em>
                            </div>
                        </dx-data-grid>
                        </div>
                        <!-- <button pButton type="button" label="Preview" [disabled]="isViewMode"
                            *ngIf='deficiencyCommentsData && deficiencyCommentsData.length > 0' icon="pi pi-check"
                            class="p-mt-4 pull-right" (click)="previewDefComments()">
                        </button> -->

                    </p-accordionTab>




                </p-accordion>

            </p-tabPanel>

            <!-- ================= TAB 2: Future Form Placeholder ================= -->
            <p-tabPanel *ngIf="analystrole && application_type != 'Name Change'">
                <ng-template pTemplate="header">
                    <div class="tab-header">
                        <i class="pi pi-briefcase"></i>
                        <span>License Builder</span>
                    </div>
                </ng-template>
                <form [formGroup]="licenseForm">

                    <!-- <p-accordion class="custom-accordion" [multiple]="true" > -->
                    <p-accordion class="custom-accordion" [multiple]="false">
                        <div formArrayName="licenses">

                            <p-accordionTab *ngFor="let license of licenses.controls; let i = index" [selected]="i === 0"
                                [header]="'License and Endorsements Review - ' + license.get('licenseKind')?.value"
                                [formGroupName]="i" [ngClass]="{ 'License-endorreviewsec-accordion': i === 0 }">

                                <!-- LICENSE FIELDS -->
                                <div class="grid licensegrid">
                                    <div class="licensegrid-inputslabel">
                                        <label [for]="'licenseKind-' + i">License Kind</label>
                                        <input [id]="'licenseKind-' + i"   pInputText formControlName="licenseKind" disabled readonly="true" />
                                    </div>
                                    <div *ngIf="license.get('licenseKind')?.touched && license.get('licenseKind')?.errors as errors"
                                        class="text-danger mt-1 err-font error-msg-text">
                                        <span *ngIf="errors['required']">License Kind is required.</span>
                                    </div>

                                    <div class="licensegrid-inputslabel">
                                        <label [for]="'licensetype-' + i">License Type
                                            <span class="requiredfield text-danger"
                                                *ngIf="!isPathwaySeven(i, i)">*</span>
                                        </label>
                                        <div [matTooltip]="getSelectLabel(license.get('licenseType')?.value, licenseTypesData)"
                                            matTooltipPosition="above" matTooltipClass="custom-tooltip">
                                            <p-dropdown [inputId]="'licensetype-' + i" [options]="licenseTypesData" placeholder="Select License Type"
                                                [autoDisplayFirst]="false" optionLabel="value" optionValue="key" [filter]="true"
                                                filterBy="value" [showClear]="false" formControlName="licenseType"
                                                (onChange)="licensetypeOnChange($event.value, i)">
                                                <ng-template let-item pTemplate="selectedItem">
                                                    <span class="dropdownselectedItem">
                                                        {{ item.value }}
                                                    </span>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>

                                        <div *ngIf="license.get('licenseType')?.errors?.['requiredForExpiration'] &&
                                                                    (license.get('expirationDate')?.value || hasAnyEndorsementExpirationDate(i))"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            Please choose License Type.
                                        </div>

                                        <div *ngIf="license.get('licenseType')?.touched && license.get('licenseType')?.errors as errors"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            <span *ngIf="errors['required']">License Type is required.</span>
                                        </div>
                                    </div>

                                    <div class="licensegrid-inputslabel licensegrid-calendarlabel">
                                        <label  [for]="'effectiveDate-' + i">Effective Date
                                            <span class="requiredfield text-danger"
                                                *ngIf="!isPathwaySeven(i, i)">*</span>
                                        </label>
                                        <div class="input-group ssn-input-group">
                                            <input   [id]="'effectiveDate-' + i"  type="text" 
                                                formControlName="effectiveDate" placeholder="Select Effective Date"
                                                data-placeholder="MM/DD/YYYY" [minDate]="today"
                                                class="form-control date-uppercase mt-1" required aria-required="true"
                                                [attr.aria-invalid]="license.get('effectiveDate')?.touched && license.get('effectiveDate')?.invalid ? 'true' : null"
                                                [attr.aria-describedby]="license.get('effectiveDate')?.touched && license.get('effectiveDate')?.invalid ? 'dob-error' : null"
                                                 maxlength="10"
                                                (input)="formatDateInput($event, license.get('effectiveDate'))" />
                                            <span class="ssn-eye">
                                                <button type="button" id="btn_registration_form_open_calendar"
                                                    class="btn p-0 eye"  tabindex="7"
                                                    (click)="openDatePicker($event,license,'effectiveDate-' + i)"
                                                    (keypress)="openDatePicker($event,license,'effectiveDate-' + i)"
                                                    title="Open Calendar" aria-label="Open date picker">
                                                    <span class="material-symbols-outlined f-20 cal">
                                                        calendar_month
                                                    </span>
                                                </button>
                                            </span>
                                        </div>
                                        <div
                                            *ngIf="license.get('effectiveDate')?.touched && license.get('effectiveDate')?.errors as errors">
                                            <div id="dob-error" *ngIf="errors['invalidDateFormat'] || errors['invalidDate']"
                                                class="text-danger mt-1 err-font error-msg-text">
                                                Enter a valid date in MM/DD/YYYY format.
                                            </div>
                                            <div id="dob-error" *ngIf="errors['invalidYear']" class="text-danger mt-1 err-font error-msg-text">
                                                Enter year between 1900 and 2100.
                                            </div>
                                            <div id="dob-error"
                                                *ngIf="license.get('effectiveDate')?.touched && license.get('effectiveDate')?.errors?.['pastDateNotAllowed']"
                                                class="text-danger mt-1 err-font error-msg-text">
                                                Date cannot be in the past.
                                            </div>
                                            <span *ngIf="license.get('effectiveDate')?.errors['required']"
                                                class="text-danger mt-1 err-font error-msg-text">
                                                Effective Date is required.
                                            </span>
                                        </div>

                                    </div>

                                    <div class="licensegrid-inputslabel">
                                        <label [for]="'expirationDate-' + i">Expiration Date
                                            <span class="requiredfield text-danger"
                                                *ngIf="!isPathwaySeven(i, i)">*</span>
                                        </label>
                                        <!-- <div>
                                                        <p-calendar formControlName="expirationDate" dateFormat="mm/dd/yy"
                                                            [showIcon]="true"
                                                            (onSelect)="onExpirationDateSelect($event, license.get('expirationDate'), i)"></p-calendar>
                                                    </div> -->

                                        <div class="input-group ssn-input-group">
                                            <input  type="text"  [id]="'expirationDate-' + i" formControlName="expirationDate"
                                                placeholder="Select Expiration Date" data-placeholder="MM/DD/YYYY"
                                                class="form-control date-uppercase mt-1" maxlength="10" (blur)="onManualDateBlur(i)"
                                                (input)="formatDateInput($event, license.get('expirationDate'))" />
                                            <span class="ssn-eye">
                                                <button type="button" class="btn p-0 eye" 
                                                    (click)="openDatePickerForControl($event, license.get('expirationDate'), 'expirationDate-' + i, i, 'lickind', i)"
                                                    (keypress)="openDatePickerForControl($event, license.get('expirationDate'), 'expirationDate-' + i, i, 'lickind', i)"
                                                    title="Open Calendar" aria-label="Open date picker">
                                                    <span class="material-symbols-outlined f-20 cal">
                                                        calendar_month
                                                    </span>
                                                </button>
                                            </span>
                                        </div>
                                        <div *ngIf="license.get('expirationDate')?.touched && license.get('expirationDate')?.errors as errors"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            <span *ngIf="errors['required']">Expiration Date is required.</span>
                                            <span *ngIf="errors['invalidDateFormat'] || errors['invalidDate']">
                                                Enter a valid date in MM/DD/YYYY format.
                                            </span>
                                            <span *ngIf="errors['invalidYear']">Enter year between 1900 and 2100.</span>
                                        </div>
                                        <div id="dob-error"
                                            *ngIf="license.get('expirationDate')?.touched && license.get('expirationDate')?.errors?.['pastDateNotAllowed']"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            Date cannot be in the past.
                                        </div>

                                        <!-- <div *ngIf="license.get('licenseType')?.errors?.['requiredForExpiration'] && license.get('expirationDate')?.touched"
                                                        class="text-danger mt-1 err-font">
                                                        Please choose License Type.
                                                    </div> -->
                                    </div>
                                </div>

                                <!-- ENDORSEMENTS -->
                                <div class="endorsement-conatiner" formArrayName="endorsements">
                                    <div *ngFor="let end of endorsements(i).controls; let j = index" [formGroupName]="j"
                                        class="endorsement-box">



                                        <div class="grid licensegrid endrosementlicensegrid-inputscontainer">
                                            <div class="licensegrid-inputslabel">
                                                <label [for]="'endorsement-' + i + '-' + j">Endorsement
                                                    <span class="requiredfield text-danger"
                                                        *ngIf="!isPathwaySeven(i, j)">*</span>
                                                </label>
                                                <div [matTooltip]="getSelectLabel(end.get('endorsement')?.value, endorsementOptionsPerLicense[i])"
                                                    matTooltipPosition="above" matTooltipClass="custom-tooltip">
                                                    <p-dropdown  [inputId]="'endorsement-' + i + '-' + j"  [options]="endorsementOptionsPerLicense[i]"
                                                        placeholder="Select Endorsement" [autoDisplayFirst]="false"
                                                        optionLabel="value" optionValue="key" [filter]="true" filterBy="value"
                                                        [showClear]="false" styleClass="Endorse-Pro-dropdown-width readonly-dropdown"
                                                        (onChange)="OnChange($event.value)" formControlName="endorsement"
                                                        (onClear)="onDropdownClear()" [readonly]="true">
                                                        <ng-template let-item pTemplate="selectedItem">
                                                            <span class="dropdownselectedItem">
                                                                {{ item.value }}
                                                            </span>
                                                        </ng-template>
                                                    </p-dropdown>
                                                </div>
                                                <div *ngIf="end.get('endorsement')?.touched && end.get('endorsement')?.errors?.['required']"
                                                    class="text-danger mt-1 err-font error-msg-text">
                                                    Endorsement is required.
                                                </div>
                                            </div>

                                            <!--  <div class="licensegrid-inputslabel">
                                                             <label>Grade
                                                                <span class="requiredfield text-danger"
                                                                    *ngIf="!isPathwaySeven(i, j)">*</span>
                                                            </label>

                                                            <input pInputText formControlName="grade" disabled readonly="true" />
                                                            <div *ngIf="end.get('grade')?.touched && end.get('grade')?.errors?.['required']"
                                                                class="text-danger mt-1 err-font">
                                                                Grade is required.
                                                            </div>
                                                        </div>-->

                                        <div class="licensegrid-inputslabel">
                                                <label [for]="'endorsemenetpathway-' + i + '-' + j">Endorsement Pathway
                                                    <span class="requiredfield text-danger"
                                                        *ngIf="!isPathwaySeven(i, j)">*</span>
                                                </label>
                                                <div [matTooltip]="getSelectLabel(end.get('pathway')?.value, endoPathwayData)"
                                                    matTooltipPosition="above" matTooltipClass="custom-tooltip">
                                                    <p-dropdown [inputId]="'endorsemenetpathway-' + i + '-' + j"  [options]="endoPathwayData" placeholder="Select Endorsement Pathway"
                                                        [autoDisplayFirst]="false" optionLabel="value" optionValue="key"
                                                        [filter]="true" (onChange)="OnendPathwayChange($event.value)"
                                                        filterBy="value" [showClear]="false" formControlName="pathway">
                                                        <ng-template let-item pTemplate="selectedItem">
                                                            <span class="dropdownselectedItem">
                                                                {{ item.value }}
                                                            </span>
                                                        </ng-template>
                                                    </p-dropdown>
                                                </div>
                                                <div *ngIf="end.get('pathway')?.touched && end.get('pathway')?.errors?.['required']"
                                                    class="text-danger mt-1 err-font error-msg-text">
                                                    Endorsement Pathway is required.
                                                </div>
                                            </div>

                                            <div class="licensegrid-inputslabel">
                                                <label [for]="'endorsementoriginalEffectiveDateInput-' + i + '-' + j">Original Effective Date
                                                    <span class="requiredfield text-danger"
                                                        *ngIf="!isPathwaySeven(i, j)">*</span>
                                                </label>
                                                <!-- <p-calendar formControlName="originalEffectiveDate" [minDate]="today"
                                                                [showIcon]="true"></p-calendar> -->
                                                <div class="input-group ssn-input-group">
                                                    <input type="text" [id]="'endorsementoriginalEffectiveDateInput-' + i + '-' + j"
                                                        formControlName="originalEffectiveDate" placeholder="Select Effective Date"
                                                        data-placeholder="MM/DD/YYYY" class="form-control date-uppercase mt-1"
                                                        maxlength="10"
                                                        (input)="formatDateInput($event, end.get('originalEffectiveDate'))" />
                                                    <span class="ssn-eye">
                                                        <button type="button" class="btn p-0 eye" 
                                                            (click)="openDatePickerForControl($event, end.get('originalEffectiveDate'), 'endorsementoriginalEffectiveDateInput-' + i + '-' + j)"
                                                            (keypress)="openDatePickerForControl($event, end.get('originalEffectiveDate'), 'endorsementoriginalEffectiveDateInput-' + i + '-' + j)"
                                                            title="Open Calendar" aria-label="Open date picker">
                                                            <span class="material-symbols-outlined f-20 cal">
                                                                calendar_month
                                                            </span>
                                                        </button>
                                                    </span>
                                                </div>
                                                <div *ngIf="end.get('originalEffectiveDate')?.touched && end.get('originalEffectiveDate')?.errors as errors"
                                                    class="text-danger mt-1 err-font error-msg-text">
                                                    <span *ngIf="errors['required']">
                                                        Original Effective Date is required.
                                                    </span>
                                                    <span *ngIf="errors['invalidDateFormat'] || errors['invalidDate']">
                                                        Enter a valid date in MM/DD/YYYY format.
                                                    </span>
                                                    <span *ngIf="errors['invalidYear']">
                                                        Enter year between 1900 and 2100.
                                                    </span>
                                                </div>
                                                <div id="dob-error"
                                                    *ngIf="!patchFromApi && end.get('originalEffectiveDate')?.errors?.pastDateNotAllowed"
                                                    class="text-danger mt-1 err-font error-msg-text">
                                                    Date cannot be in the past.
                                                </div>
                                                <!-- <div *ngIf="end.get('originalEffectiveDate')?.touched && end.get('originalEffectiveDate')?.errors?.['required']"
                                                                class="text-danger mt-1 err-font">
                                                                Original Effective Date is required.
                                                            </div> -->
                                            </div>
                                            <div class="licensegrid-inputslabel">
                                                <label [for]="'endorsementEffectiveDateInput-' + i + '-' + j">Effective Date
                                                    <span class="requiredfield text-danger"
                                                        *ngIf="!isPathwaySeven(i, j)">*</span>
                                                </label>
                                                <div class="input-group ssn-input-group">
                                                    <input type="text" [id]="'endorsementEffectiveDateInput-' + i + '-' + j"
                                                        formControlName="effectiveDate" placeholder="Select Effective Date"
                                                        data-placeholder="MM/DD/YYYY" class="form-control date-uppercase mt-1"
                                                        maxlength="10"
                                                        (input)="formatDateInput($event, end.get('effectiveDate'))" />
                                                    <span class="ssn-eye">
                                                        <button type="button" class="btn p-0 eye" 
                                                            (click)="openDatePickerForControl($event, end.get('effectiveDate'), 'endorsementEffectiveDateInput-' + i + '-' + j)"
                                                            (keypress)="openDatePickerForControl($event, end.get('effectiveDate'), 'endorsementEffectiveDateInput-' + i + '-' + j)"
                                                            title="Open Calendar" aria-label="Open date picker">
                                                            <span class="material-symbols-outlined f-20 cal">
                                                                calendar_month
                                                            </span>
                                                        </button>
                                                    </span>
                                                </div>
                                                <div *ngIf="end.get('effectiveDate')?.touched && end.get('effectiveDate')?.errors as errors"
                                                    class="text-danger mt-1 err-font error-msg-text">
                                                    <span *ngIf="errors['required']">
                                                        Effective Date is required.
                                                    </span>
                                                    <span *ngIf="errors['invalidDateFormat'] || errors['invalidDate']">
                                                        Enter a valid date in MM/DD/YYYY format.
                                                    </span>
                                                    <span *ngIf="errors['invalidYear']">
                                                        Enter year between 1900 and 2100.
                                                    </span>
                                                </div>
                                                <div id="dob-error"
                                                    *ngIf="!patchFromApi && end.get('effectiveDate')?.errors?.pastDateNotAllowed"
                                                    class="text-danger mt-1 err-font error-msg-text">
                                                    Date cannot be in the past.
                                                </div>
                                            </div>

                                            <div class="licensegrid-inputslabel">
                                                <label for="endorsementexpirationDateInput">Expiration Date
                                                    <span class="requiredfield text-danger"
                                                        *ngIf="!isPathwaySeven(i, j)">*</span>
                                                </label>
                                                <div class="input-group ssn-input-group">
                                                    <input type="text" [id]="'endorsementexpirationDateInput-' + i + '-' + j"
                                                        formControlName="expirationDate" placeholder="Select Expiration Date"
                                                        data-placeholder="MM/DD/YYYY" class="form-control date-uppercase mt-1"
                                                        maxlength="10" (blur)="onManualEndorsementDateBlur(i, j)"
                                                        (input)="formatDateInput($event, end.get('expirationDate'))" />
                                                    <span class="ssn-eye">
                                                        <button type="button" class="btn p-0 eye" tabindex="7"
                                                            (click)="openDatePickerForControl($event, end.get('expirationDate'), 'endorsementexpirationDateInput-' + i + '-' + j, i, 'lickind', i)"
                                                            (keypress)="openDatePickerForControl($event, end.get('expirationDate'), 'endorsementexpirationDateInput-' + i + '-' + j, i, 'lickind',i)"
                                                            title="Open Calendar" aria-label="Open date picker">
                                                            <span class="material-symbols-outlined f-20 cal">
                                                                calendar_month
                                                            </span>
                                                        </button>
                                                    </span>
                                                </div>
                                                <!-- <div class="input-group ssn-input-group">
                                                                <input type="text"
                                                                    [id]="'endorsementexpirationDateInput-' + i + '-' + j"
                                                                    formControlName="expirationDate" placeholder="MM/DD/YYYY"
                                                                    data-placeholder="MM/DD/YYYY"
                                                                    class="form-control date-uppercase mt-1" maxlength="10"
                                                                    (input)="formatDateInput($event, end.get('expirationDate'))" />
                                                                <span class="ssn-eye">
                                                                    <button type="button" class="btn p-0 eye" tabindex="7"
                                                                        (click)="openDatePickerForControl($event, end.get('expirationDate'), 'endorsementexpirationDateInput-' + i + '-' + j, i, 'lickind', i)"
                                                                        (keypress)="openDatePickerForControl($event, end.get('expirationDate'), 'endorsementexpirationDateInput-' + i + '-' + j, i, 'lickind', i)"
                                                                        title="Open Calendar" aria-label="Open date picker">
                                                                        <span class="material-symbols-outlined f-20 cal">
                                                                            calendar_month
                                                                        </span>
                                                                    </button>
                                                                </span>
                                                            </div> -->
                                                <div *ngIf="end.get('expirationDate')?.touched && end.get('expirationDate')?.errors as errors"
                                                    class="text-danger mt-1 err-font error-msg-text">
                                                    <span *ngIf="errors['required']">
                                                        Expiration Date is required.
                                                    </span>
                                                    <span *ngIf="errors['invalidDateFormat'] || errors['invalidDate']">
                                                        Enter a valid date in MM/DD/YYYY format.
                                                    </span>
                                                    <span *ngIf="errors['invalidYear']">
                                                        Enter year between 1900 and 2100.
                                                    </span>
                                                </div>
                                                <div id="dob-error" *ngIf="end.get('expirationDate')?.errors?.pastDateNotAllowed"
                                                    class="text-danger mt-1 err-font error-msg-text">
                                                    Date cannot be in the past.
                                                </div>
                                                <!-- <div *ngIf="license.get('licenseType')?.errors?.['requiredForExpiration'] && end.get('expirationDate')?.touched"
                                                                class="text-danger mt-1 err-font">
                                                                Please choose License Type.
                                                            </div> -->
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </p-accordionTab>

                        </div>


                        <p-accordionTab [header]="'License / Endorsement Provisions'">
                            <!-- ================= LICENSE PROVISIONS ================= -->

                            <form [formGroup]="prolickindForm" class="entry-form">

                                <div class="p-fluid p-formgrid p-grid licensegrid">

                                    <!-- Category Dropdown -->
                                    <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                                        <label for="category">Category<span class="requiredfield text-danger">*</span></label>
                                        <div [matTooltip]="getSelectLabel(prolickindForm.get('category')?.value,
                                            [{key:'License Kind',value:'License Kind'},{key:'Endorsement',value:'Endorsement'}])"
                                        matTooltipPosition="above" matTooltipClass="custom-tooltip">
                                        <p-dropdown id="category"
                                            [options]="[{key:'License Kind',value:'License Kind'},{key:'Endorsement',value:'Endorsement'}]"
                                            [autoDisplayFirst]="false" optionLabel="value" optionValue="key"
                                            placeholder="Select Category" formControlName="category"
                                            (onChange)="onCategoryChange()"
                                            [filter]="false" [showClear]="false"
                                            styleClass="fixed-dropdown-width">
                                        </p-dropdown>
                                        </div>
                                        <div *ngIf="prolickindForm.get('category')?.touched && prolickindForm.get('category')?.errors?.['required']"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            Category is required.
                                        </div>
                                    </div>

                                    <!-- Source -->
                                    <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                                        <label for="provlickind">Source<span class="requiredfield text-danger">*</span></label>

                                        <div [matTooltip]="getMultiSelectLabel(prolickindForm.get('provlickind')?.value, provisionSourceOptions)"
                                        matTooltipPosition="above" matTooltipClass="custom-tooltip">
                                        <p-multiSelect
                                            [options]="provisionSourceOptions"
                                            placeholder="Select Source"
                                            optionLabel="value" optionValue="key" [filter]="true" filterBy="value"
                                            [showClear]="true" [closeOnSelect]="false" [appendTo]="'body'"
                                            display="chip"
                                            styleClass="sourcedropdownchoice"
                                            [disabled]="!prolickindForm.get('category')?.value"
                                            (onChange)="onProvisionSourceChange($event)"
                                            (onClear)="onProvisionSourceChange($event)"
                                            formControlName="provlickind">
                                        </p-multiSelect>
                                        </div>

                                        <div *ngIf="prolickindForm.get('provlickind')?.touched && prolickindForm.get('provlickind')?.errors as errors"
                                            class="text-danger mt-1 err-font endorsementerrormsg error-msg-text">
                                            <span *ngIf="errors['required']">Source is required.</span>
                                        </div>
                                    </div>

                                    <!-- Provision Type Dropdown -->
                                    <!-- <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                                                    <label for="provision">Provision Type</label>
                                                    <p-dropdown id="provision" [options]="licenseProvisionsData"
                                                        [autoDisplayFirst]="false" optionLabel="value" optionValue="key"
                                                        placeholder="Select" (onChange)="provtypeOnChange($event.value)"
                                                        (onClear)="onDropdownClear()" formControlName="lickindprovisiontype"
                                                        [filter]="true" [showClear]="true">
                                                    </p-dropdown>
                                                </div> -->

                                    <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                                        <label for="licenseprovision">Provision<span class="requiredfield text-danger">*</span></label>
                                       <div [matTooltip]="getSelectLabel(prolickindForm.get('lickindprovision')?.value,
                               prolickindForm.get('category')?.value === 'Endorsement' ? licendoProvTypedata : lickindProvTypedata)"
                                            matTooltipPosition="above" matTooltipClass="custom-tooltip">
                                       <p-dropdown inputId="licenseprovision"
                                            [options]="prolickindForm.get('category')?.value === 'Endorsement' ? licendoProvTypedata : lickindProvTypedata"
                                            [autoDisplayFirst]="false"
                                            optionLabel="value" optionValue="key" placeholder="Select Provision"
                                            (onChange)="lickindprovisionOnChange($event.value)"
                                            formControlName="lickindprovision" [filter]="true" [showClear]="false"
                                            styleClass="fixed-dropdown-width"
                                            panelStyleClass="provision-dropdown-panel"
                                            >
                                        </p-dropdown>
                                        </div>
                                        <div *ngIf="prolickindForm.get('lickindprovision')?.touched && prolickindForm.get('lickindprovision')?.errors as errors"
                                            class="text-danger mt-1 err-font endorsementerrormsg error-msg-text">
                                            <span *ngIf="errors['required']">Provision is required.</span>
                                        </div>
                                    </div>


                                    <!-- Due Date -->
                                    <div class=" provisionlabelinput mb-0">
                                        <label for="provdueDateInput">Due Date<span
                                                class="requiredfield text-danger">*</span></label>
                                        <div class="input-group ssn-input-group">
                                            <input type="text" id="provdueDateInput" formControlName="provdueDate"
                                                placeholder="Select Due Date" data-placeholder="MM/DD/YYYY"
                                                class="form-control date-uppercase mt-1" maxlength="10"
                                                (onSelect)="onProvDueDateChange($event, null, 'prolickind')"
                                                (blur)="onProvDueDateChange(prolickindForm.get('provdueDate')?.value, null, 'prolickind')"
                                                (input)="formatDateInput($event, prolickindForm.get('provdueDate'))" />
                                            <span class="ssn-eye">
                                                <button type="button" class="btn p-0 eye" 
                                                    (click)="openDatePickerForControl($event, prolickindForm.get('provdueDate'), 'provdueDateInput', undefined, 'prolickind')"
                                                    (keypress)="openDatePickerForControl($event, prolickindForm.get('provdueDate'), 'provdueDateInput', undefined, 'prolickind')"
                                                    title="Open Calendar" aria-label="Open date picker">
                                                    <span class="material-symbols-outlined f-20 cal">
                                                        calendar_month
                                                    </span>
                                                </button>
                                            </span>
                                        </div>
                                        <div *ngIf="prolickindForm.get('provdueDate')?.touched && prolickindForm.get('provdueDate')?.errors as errors"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            <span *ngIf="errors['required']">Due Date is required.</span>
                                            <span *ngIf="errors['invalidDateFormat'] || errors['invalidDate']">
                                                Enter a valid date in MM/DD/YYYY format.
                                            </span>
                                            <span *ngIf="errors['invalidYear']">Enter year between 1900 and 2100.</span>
                                        </div>
                                        <div id="dob-error"
                                            *ngIf="prolickindForm.get('provdueDate')?.touched && prolickindForm.get('provdueDate')?.errors?.['pastDateNotAllowed']"
                                            class="text-danger mt-1 err-font endorsementerrormsg error-msg-text">
                                            Date cannot be in the past.
                                        </div>
                                    </div>
                                    <!-- <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                                                    <label for="input_registration_form_date_of_birth">Due Date<span
                                                            class="requiredfield text-danger">*</span></label>
                                                    <div class="input-group ssn-input-group">
                                                        <input type="text" id="dueDate" formControlName="provdueDate"
                                                            placeholder="Select Due Date" data-placeholder="MM/DD/YYYY"
                                                            class="form-control date-uppercase mt-1" required aria-required="true"
                                                            tabindex="6" maxlength="10" (input)="formatDateInput($event)" />
                                                        <span class="ssn-eye">
                                                            <button type="button" id="btn_registration_form_open_calendar"
                                                                class="btn p-0 eye" tabindex="7"
                                                                (click)="onProvDueDateChange($event,i)"
                                                                (keypress)="openDatePicker($event)" title="Open Calendar"
                                                                aria-label="Open date picker">
                                                                <span class="material-symbols-outlined f-20 cal">
                                                                    calendar_month
                                                                </span>
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div> -->


                                    <!-- Additional Text -->
                                    <div class=" provisionlabelinput">
                                        <label for="licenseadditionalText">Additional Text</label>
                                        <textarea rows="2" cols="30" pInputTextarea maxlength="500" id="licenseadditionalText"
                                            formControlName="provlickindaddText" placeholder="Enter Additional Text"
                                            class="autoheighttextarea"></textarea>
                                        <!-- <div *ngIf="prolickindForm.get('provlickindaddText')?.touched && prolickindForm.get('provlickindaddText')?.errors as errors"
                                                    class="text-danger err-font endorsementerrormsg">
                                                    <span *ngIf="errors['required']">Additional Text is required.</span>
                                                </div> -->
                                    </div>
                                </div>
                                <!-- Action Buttons -->
                                <div class="p-mt-2 p-d-flex p-jc-end Licenseactionbtn">
                                    <button type="button" pButton label="Reset" icon="pi pi-refresh" [disabled]="isViewMode"
                                        class="p-button-secondary p-mr-2" (click)="resetLicense()">
                                    </button>

                                    <button type="button" *ngIf="!provlickindeditbtn" pButton label="Add" [disabled]="isViewMode"
                                        icon="pi pi-plus" class="p-button-success" (click)="addProvision()">
                                    </button>

                                </div>


                            </form>
                            <br />
                            <!-- <dx-data-grid [dataSource]="licKindProvisionRows" [searchPanel]="{ visible: false }"
                                    [showBorders]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true"
                                    [paging]="{ enabled: false }" [noDataText]="'No data'" class="card" [columnMinWidth]="120" >

                                    <dxi-column dataField="provlicenseKind" caption="License Kind"></dxi-column>
                                    <dxi-column dataField="provision" caption="Provision"></dxi-column>
                                    <dxi-column dataField="dueDate" caption="Due Date" dataType="date"></dxi-column>
                                    <dxi-column dataField="additionalText" caption="Additional Text"></dxi-column>

                                    <dxi-column caption="Action" type="buttons">
                                        <dxi-button icon="eye"></dxi-button>
                                        <dxi-button icon="edit"></dxi-button>
                                        <dxi-button icon="trash" (click)="deleteRow($event.row.data.id)">
                                        </dxi-button>
                                    </dxi-column>

                                </dx-data-grid> -->

                            <div class="decisionactionsgrid">
                            <dx-data-grid #combinedProvisionsGrid  [dataSource]="combinedProvisionRows" [keyExpr]="'lickind_id'" [showBorders]="true"
                                [rowAlternationEnabled]="true" [columnAutoWidth]="true" [wordWrapEnabled]="isWordWrapEnabled"
                                [allowColumnResizing]="true" [columnResizingMode]="'widget'"
                                [width]="'100%'" [columnMinWidth]="80"
                                (onContentReady)="setActionColumnWidth($event)">
                                <dxo-scrolling  mode="standard" showScrollbar="always" useNative="true"></dxo-scrolling>
                                <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
                                <dxo-header-filter [visible]="false"></dxo-header-filter>
                                <dxo-paging [pageSize]="10"></dxo-paging>

                                <dxo-pager [visible]="true" [allowedPageSizes]="[10, 25, 50, 100]" [displayMode]="displayMode"
                                    [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
                                <dxo-sorting mode="multiple"></dxo-sorting>

                                <ng-container *ngFor="let column of combinedProvisionGridConfig; let i = index">
                                    <ng-container *ngIf="column.hide !== true">
                                        <ng-container *ngIf="column.truncate; else noTruncate">
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter" [width]="column.width"
                                                cellTemplate="truncateTemplate">
                                            </dxi-column>
                                        </ng-container>

                                        <ng-template #noTruncate>
                                            <ng-container *ngIf="column.link; else noLink">
                                                <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                    [allowFiltering]="column.filter" cellTemplate="cellTemplate"></dxi-column>
                                            </ng-container>
                                            <ng-template #noLink>
                                                <ng-container *ngIf="column.icon; else noIcon">
                                                    <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                        [allowFiltering]="column.filter" cellTemplate="iconTemplate"></dxi-column>
                                                </ng-container>
                                            </ng-template>
                                            <ng-template #noIcon>
                                                <ng-container *ngIf="column.dateFormat; else noDate">
                                                    <dxi-column
                                                        *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                                                        [dataField]="column.columnDef" [caption]="column.header"
                                                        [allowFiltering]="column.filter" [dataType]="'date'" format="MM/dd/yyyy">
                                                    </dxi-column>
                                                </ng-container>
                                            </ng-template>
                                            <ng-template #noDate>
                                                <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                    [allowFiltering]="column.filter">
                                                </dxi-column>
                                            </ng-template>
                                        </ng-template>

                                    </ng-container>
                                </ng-container>
                                <dxi-column *ngIf="isVisible || isActionVisible" caption="Actions" [width]="actionColumnWidth"
                                    [allowSorting]="false" cellTemplate="actionsTemplate" [fixed]="true" fixedPosition="right"></dxi-column>
                                <dxo-scrolling mode="standard" showScrollbar="onHover" [useNative]="false"></dxo-scrolling>

                                <div *dxTemplate="let data of 'actionsTemplate'" class="licenseactioncontainer">
                                    <button class="fa fa-edit action-icon-button" [disabled]="isViewMode"
                                        [ngStyle]="{ 'display': (isShowEdit === true) ? 'inline-block' : 'none' }" pTooltip="Edit"
                                        tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="data?.data?.category === 'Endorsement' ? onLicEndoProvisionEdit(data, editModel1) : onLicKindProvisionEdit(data, editModel)">
                                        <span class="sr-only">Edit</span>
                                    </button>
                                    <button class="fa fa-eye action-icon-button" [disabled]="isViewMode"
                                        [ngStyle]="{ 'display': (isShowView === true) ? 'inline-block' : 'none' }" pTooltip="View"
                                        tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onView(data)">
                                        <span class="sr-only">View</span>
                                    </button>
                                    <button class="fa fa-trash action-icon-button deletebtn" [disabled]="isViewMode"
                                        [ngStyle]="{ 'display': (isShowDelete === true) ? 'inline-block' : 'none' }"
                                        pTooltip="Delete" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="onLicKindProvisionDelete(data, deleteModel)">
                                        <span class="sr-only">Delete</span>
                                    </button>
                                    <button class="fa fa-check-circle ml-1" [disabled]="isViewMode"
                                        *ngIf="isShowMarkAsAddressed === true && data?.data?.notes_type === 'Deficiency' &&  (!data?.data?.review_status || data?.data?.review_status === 'Deficient' || data?.data?.review_status === 'Pending Review')"
                                        pTooltip="Mark as Addressed" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="onMarkAsAddressed(data, confirmAddressedModel)">
                                        <span class="sr-only">Mark as Addressed</span>
                                    </button>
                                    <button class="fa fa-check ml-1" [disabled]="isViewMode"
                                        *ngIf="isShowMarkAsValid === true && data?.data?.notes_type === 'Deficiency' && data?.data?.review_status === 'Addressed'"
                                        pTooltip="Mark as Valid" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="onMarkAsValid(data, confirmValidationModel)">
                                        <span class="sr-only">Mark as Valid</span>
                                    </button>
                                    <button class="fa fa-exclamation-triangle ml-1" [disabled]="isViewMode"
                                        *ngIf="isShowMarkAsDificient === true && data?.data?.notes_type === 'Deficiency' && data?.data?.review_status === 'Addressed'"
                                        pTooltip="Mark as Deficient" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="onMarkAsDeficient(data, confirmDeficiencyModel)">
                                        <span class="sr-only">Mark Deficient</span>
                                    </button>

                                    <button class="action-icon-button resolution-btn"
                                        *ngIf="shouldShowApproveResolution(data.data)"
                                        pTooltip="Approve Resolution Request" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="onApproveResolution(data, approveResolutionModel)">
                                        <span class="sr-only">Approve Resolution</span>
                                        <img src="/assets/images/neveda-images/Default_approve_request.svg" alt="Approve Resolution" class="action-icon-svg icon-default" />
                                        <img src="/assets/images/neveda-images/Active_approve_request.svg" alt="Approve Resolution" class="action-icon-svg icon-active" />
                                    </button>

                                    <button class="action-icon-button cancel-resolution-btn"
                                        *ngIf="shouldShowDenyResolution(data.data)"
                                        pTooltip="Deny Resolution Request" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="onDenyResolution(data, denyResolutionModel)">
                                        <span class="sr-only">Deny Resolution</span>
                                        <img src="/assets/images/neveda-images/Default_deny_request.svg" alt="Deny Resolution" class="action-icon-svg icon-default" />
                                        <img src="/assets/images/neveda-images/Active_deny_request.svg" alt="Deny Resolution" class="action-icon-svg icon-active" />
                                    </button>

                                    <button class="action-icon-button view-resolution-notes-btn"
                                        *ngIf="shouldShowViewResolutionNotes(data.data)"
                                        pTooltip="View Resolution Notes" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="onViewResolutionNotes(data, viewResolutionNotesModel)">
                                        <span class="sr-only">View Resolution Notes</span>
                                        <span class="material-symbols-outlined">comment</span>
                                    </button>

                                </div>
                                <div *dxTemplate="let d of 'truncateTemplate'">
                                    <span [pTooltip]="d.value && d.value.length > 100 ? d.value : ''" tooltipPosition="top"
                                        tooltipStyleClass="custom-additionals-tooltip" class="custom-turncate-data">
                                        {{ d.value && d.value.length > 100 ? (d.value | slice:0:100) + '...' : d.value }}
                                    </span>
                                </div>
                                <div *dxTemplate="let d of 'cellTemplate'">
                                    <span href="javascript:void(0)" *ngIf="d.value && d.value !== 'null'" class="link-data"
                                        (click)="getRouter(d)">{{
                                        d.value !== 'null' ? d.value : ''
                                        }}</span>
                                </div>
                                <ng-container>
                                    <div *dxTemplate="let d of 'cellTemplate'">
                                        <span *ngIf="d.value && d.value !== 'null'" #contentWrapper
                                            [innerHTML]="d.value | safeHtml">{{
                                            d.value !== 'null' ? d.value : ''
                                            }}</span>
                                    </div>
                                </ng-container>
                                <div *dxTemplate="let d of 'iconTemplate'">
                                    <em class="fa fa-book"></em>
                                </div>
                            </dx-data-grid>
                            </div>


                        </p-accordionTab>


                        <p-accordionTab [header]="'License Requirements'">
                            <!-- ================= LICENSE REQUIREMENTS ================= -->



                            <form [formGroup]="prolicreqForm" class="entry-form">

                                <div class="p-fluid p-formgrid p-grid licensegrid ">
                                    <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                                        <label for="categorytype">Category
                                            <span class="requiredfield text-danger">*</span>
                                        </label>

                                        <div [matTooltip]="getSelectLabel(prolicreqForm.get('type')?.value, typeOptions)"
                                            matTooltipPosition="above" matTooltipClass="custom-tooltip">
                                            <p-dropdown inputId="categorytype" [options]="typeOptions" [autoDisplayFirst]="false"
                                                optionLabel="value" optionValue="key" placeholder="Select Category" formControlName="type"
                                                [filter]="true" [showClear]="false">
                                                <ng-template let-item pTemplate="selectedItem">
                                                    <span class="dropdownselectedItem">
                                                        {{ item.value }}
                                                    </span>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>

                                        <div *ngIf="prolicreqForm.get('type')?.touched
                                                                                        && prolicreqForm.get('type')?.errors?.['required']"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            Category is required.
                                        </div>
                                    </div>

                                    <!-- Source Dropdown -->
                                    <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                                        <label for="source">
                                            Source
                                            <span class="requiredfield text-danger">*</span>
                                        </label>

                                        <div [matTooltip]="getMultiSelectLabel(prolicreqForm.get('source')?.value, sourceOptions)"
                                            matTooltipPosition="above" matTooltipClass="custom-tooltip">
                                        <p-multiSelect  inputId="source" placeholder="Select Source" optionLabel="value" optionValue="key"
                                            [filter]="true" filterBy="value" [showClear]="true" formControlName="source"
                                            [closeOnSelect]="false" display="chip"
                                            (onChange)="onSourceChange($event,prolicreqForm.get('type'))"
                                            [disabled]="!prolicreqForm.get('type')?.value" [options]="sourceOptions"
                                            [appendTo]="'body'" styleClass="fixed-dropdown-width"
                                            (onClear)="onSourceChange($event)">
                                        </p-multiSelect>
                                        </div>

                                        <div *ngIf="prolicreqForm.get('source')?.touched
                                                    && prolicreqForm.get('source')?.errors?.['required']"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            Source is required.
                                        </div>
                                    </div>


                                    <!-- Provision Dropdown -->
                                    <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                                        <label for="requirement">Requirement<span
                                                class="requiredfield text-danger">*</span></label>
                                        <div [matTooltip]="getSelectLabel(prolicreqForm.get('licrequirement')?.value, licrequirementsData)"
                                            matTooltipPosition="above" matTooltipClass="custom-tooltip">
                                            <p-dropdown id="requirement" [options]="getFilteredRequirementOptions(prolicreqForm.get('type')?.value)"
                                                [autoDisplayFirst]="false" required optionLabel="value" optionValue="key"
                                                placeholder="Select Requirement" formControlName="licrequirement" [filter]="true"
                                                [showClear]="false" styleClass="fixed-dropdown-width">
                                                <ng-template let-item pTemplate="selectedItem">
                                                    <span class="dropdownselectedItem">
                                                        {{ item.value }}
                                                    </span>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                        <div *ngIf="prolicreqForm.get('licrequirement')?.touched && prolicreqForm.get('licrequirement')?.errors as errors"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            <span *ngIf="errors['required']">Requirement is required.</span>
                                        </div>

                                    </div>
                                    <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                                        <label for="reqdueDateInput">Due Date<span
                                                class="requiredfield text-danger">*</span></label>
                                        <div class="input-group ssn-input-group">
                                            <input type="text" id="reqdueDateInput" formControlName="reqdueDate"
                                                placeholder="Select Due Date" data-placeholder="MM/DD/YYYY"
                                                class="form-control date-uppercase mt-1" required aria-required="true" tabindex="6"
                                                maxlength="10" (onSelect)="onProvDueDateChange($event, null, 'prolicreq')"
                                                (blur)="onProvDueDateChange(prolicreqForm.get('reqdueDate')?.value, null, 'prolicreq')"
                                                (input)="formatDateInput($event, prolicreqForm.get('reqdueDate'))" />
                                            <span class="ssn-eye">
                                                <button type="button" id="btn_registration_form_open_calendar" class="btn p-0 eye"
                                                    tabindex="7"
                                                    (click)="openDatePickerForControl($event, prolicreqForm.get('reqdueDate'), 'reqdueDateInput', undefined, 'prolicreq')"
                                                    (keypress)="openDatePickerForControl($event, prolicreqForm.get('reqdueDate'), 'reqdueDateInput', undefined, 'prolicreq')"
                                                    title="Open Calendar" aria-label="Open date picker">
                                                    <span class="material-symbols-outlined f-20 cal">
                                                        calendar_month
                                                    </span>
                                                </button>
                                            </span>
                                        </div>
                                        <div *ngIf="prolicreqForm.get('reqdueDate')?.touched && prolicreqForm.get('reqdueDate')?.errors as errors"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            <span *ngIf="errors['required']">Due Date is required.</span>
                                            <span *ngIf="errors['invalidDateFormat'] || errors['invalidDate']">
                                                Enter a valid date in MM/DD/YYYY format.
                                            </span>
                                            <span *ngIf="errors['invalidYear']">Enter year between 1900 and 2100.</span>
                                        </div>
                                        <div id="dob-error"
                                            *ngIf="prolicreqForm.get('reqdueDate')?.touched && prolicreqForm.get('reqdueDate')?.errors?.['pastDateNotAllowed']"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            Date cannot be in the past.
                                        </div>
                                    </div>
                                </div>
                                <!-- Action Buttons -->
                                <div class="p-mt-5 p-d-flex p-jc-end Licenseactionbtn">
                                    <button type="button" pButton label="Reset" icon="pi pi-refresh" [disabled]="isViewMode"
                                        class="p-button-secondary p-mr-2" (click)="resetLicenseRequirements()">
                                    </button>
                                    <button type="button" *ngIf="!provlicreqeditbtn" pButton label="Add" [disabled]="isViewMode"
                                        icon="pi pi-plus" class="p-button-success" (click)="addLicenseRequirements()">
                                    </button>
                                    <button type="button" *ngIf="provlicreqeditbtn" pButton label="Update" [disabled]="isViewMode"
                                        icon="pi pi-plus" class="p-button-success" [disabled]="!prolicreqForm.valid"
                                        (click)="updateLicenseRequirements()">
                                    </button>
                                </div>


                            </form>
                            <br />
                            <!-- <dx-data-grid [dataSource]="licenseRequirementRows" [showBorders]="true" [columnAutoWidth]="true"
                                    [searchPanel]="{ visible: false }" [filterRow]="{ visible: true }">

                                    <dxi-column dataField="requirement" caption="License Requirement"></dxi-column>
                                    <dxi-column dataField="reqdueDate" caption="Due Date" dataType="date"></dxi-column>

                                    <dxi-column caption="Action" type="buttons">
                                        <dxi-button icon="eye"></dxi-button>
                                        <dxi-button icon="edit"></dxi-button>
                                        <dxi-button icon="trash" (click)="deleteRow($event.row.data.id)">
                                        </dxi-button>
                                    </dxi-column>

                                </dx-data-grid> -->
                            <div class="decisionactionsgrid">

                            <dx-data-grid #dataGrid [dataSource]="licenseRequirementRows" [keyExpr]="'lickind_id'" [showBorders]="true"
                                [rowAlternationEnabled]="true" [columnAutoWidth]="true" [wordWrapEnabled]="isWordWrapEnabled"
                                [allowColumnResizing]="true" [columnResizingMode]="'widget'"
                                [width]="'100%'" [columnMinWidth]="80"
                                (onContentReady)="setActionColumnWidth($event)">

                                <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
                                <dxo-header-filter [visible]="false"></dxo-header-filter>
                                <dxo-paging [pageSize]="10"></dxo-paging>
                                <dxo-pager [visible]="true" [allowedPageSizes]="[10, 25, 50, 100]" [displayMode]="displayMode"
                                    [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
                                <dxo-sorting mode="multiple"></dxo-sorting>
                                <dxo-scrolling  mode="standard" showScrollbar="always" useNative="true"></dxo-scrolling>
                                <ng-container *ngFor="let column of licreqgridConfig; let i = index">
                                    <ng-container *ngIf="column.hide !== true">
                                        <ng-container *ngIf="column.link; else noLink">
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter" cellTemplate="cellTemplate"></dxi-column>
                                        </ng-container>
                                        <ng-template #noLink>
                                            <ng-container *ngIf="column.icon; else noIcon">
                                                <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                    [allowFiltering]="column.filter" cellTemplate="iconTemplate"></dxi-column>
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #noIcon>
                                            <ng-container *ngIf="column.dateFormat; else noDate">
                                                <dxi-column *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                                                    [dataField]="column.columnDef" [caption]="column.header"
                                                    [allowFiltering]="column.filter" [dataType]="'date'" format="MM/dd/yyyy">
                                                </dxi-column>
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #noDate>
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter">
                                            </dxi-column>
                                        </ng-template>
                                    </ng-container>
                                </ng-container>
                                <dxi-column *ngIf="isVisible || isActionVisible" caption="Actions" [width]="actionColumnWidth"
                                    [allowSorting]="false" cellTemplate="actionsTemplate" [fixed]="true" fixedPosition="right"></dxi-column>
                                <dxo-scrolling mode="standard" showScrollbar="onHover" [useNative]="false"></dxo-scrolling>

                                <div *dxTemplate="let data of 'actionsTemplate'" class="licenseactioncontainer">
                                    <button class="fa fa-edit action-icon-button" [disabled]="isViewMode"
                                        [ngStyle]="{ 'display': (isShowEdit === true) ? 'inline-block' : 'none' }" pTooltip="Edit"
                                        tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="onLicRequirementEdit(data,editModel2)">
                                        <span class="sr-only">Edit</span>
                                    </button>
                                    <button class="fa fa-eye action-icon-button" [disabled]="isViewMode"
                                        [ngStyle]="{ 'display': (isShowView === true) ? 'inline-block' : 'none' }" pTooltip="View"
                                        tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onView(data)">
                                        <span class="sr-only">View</span>
                                    </button>
                                    <button class="fa fa-trash action-icon-button deletebtn" [disabled]="isViewMode"
                                        [ngStyle]="{ 'display': (isShowDelete === true) ? 'inline-block' : 'none' }"
                                        pTooltip="Delete" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="onLicRequirementDeletePopup(data, deleteModel1)">
                                        <span class="sr-only">Delete</span>
                                    </button>

                                    <button class="action-icon-button resolution-btn"
                                        *ngIf="shouldShowApproveResolution(data.data)"
                                        pTooltip="Approve Resolution Request" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="onApproveResolutionReq(data, approveResolutionReqModel)">
                                        <span class="sr-only">Approve Resolution</span>
                                        <img src="/assets/images/neveda-images/Default_approve_request.svg" alt="Approve Resolution" class="action-icon-svg icon-default" />
                                        <img src="/assets/images/neveda-images/Active_approve_request.svg" alt="Approve Resolution" class="action-icon-svg icon-active" />
                                    </button>

                                    <button class="action-icon-button cancel-resolution-btn"
                                        *ngIf="shouldShowDenyResolution(data.data)"
                                        pTooltip="Deny Resolution Request" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="onDenyResolutionReq(data, denyResolutionReqModel)">
                                        <span class="sr-only">Deny Resolution</span>
                                        <img src="/assets/images/neveda-images/Default_deny_request.svg" alt="Deny Resolution" class="action-icon-svg icon-default" />
                                        <img src="/assets/images/neveda-images/Active_deny_request.svg" alt="Deny Resolution" class="action-icon-svg icon-active" />
                                    </button>

                                    <button class="action-icon-button view-resolution-notes-btn"
                                        *ngIf="shouldShowViewResolutionNotes(data.data)"
                                        pTooltip="View Resolution Notes" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="onViewResolutionNotesReq(data, viewResolutionNotesReqModel)">
                                        <span class="sr-only">View Resolution Notes</span>
                                        <span class="material-symbols-outlined">comment</span>
                                    </button>

                                </div>
                                <div *dxTemplate="let d of 'cellTemplate'">
                                    <span href="javascript:void(0)" *ngIf="d.value && d.value !== 'null'" class="link-data"
                                        (click)="getRouter(d)">{{
                                        d.value !== 'null' ? d.value : ''
                                        }}</span>
                                </div>
                                <ng-container>
                                    <div *dxTemplate="let d of 'cellTemplate'">
                                        <span *ngIf="d.value && d.value !== 'null'" #contentWrapper
                                            [innerHTML]="d.value | safeHtml">{{
                                            d.value !== 'null' ? d.value : ''
                                            }}</span>
                                    </div>
                                </ng-container>
                                <div *dxTemplate="let d of 'iconTemplate'">
                                    <em class="fa fa-book"></em>
                                </div>
                            </dx-data-grid>

                            </div>

                        </p-accordionTab>

                        <p-accordionTab *ngIf="showDnqCommunication" [header]="'DNQ Communication - External'">
                            <p-editor formControlName="dnqdescription" (onInit)="onEditordnqdescriptionInit($event)"
                                [style]="{ height: '300px' }" [ngClass]="{ 'custom-disabled-editor': isViewMode }"
                                [disabled]="isViewMode"></p-editor>
                            <small class="p-error"
                                *ngIf="licenseForm.get('dnqdescription')?.value == null || licenseForm.get('dnqdescription')?.value == ''">
                                {{ errorMessages['M0158'] || 'DNQ Communication is required to preview.' }}
                            </small>
                            <div class="mt-3">
                                <button class="btn btn-cancel" icon="pi pi-eye" *ngIf="showDnqCommunication" pButton type="button"
                                    label="Preview" (click)="showDnqDialog()" style="gap:0px" [disabled]="isViewMode"></button>
                            </div>

                        </p-accordionTab>

                        <p-accordionTab [header]="'Internal Notes'">
                            <div class="decisionactionsgrid">

                        <dx-data-grid #dataGrid [dataSource]="internalCommentsData" [showBorders]="true"
                            [rowAlternationEnabled]="true" [columnAutoWidth]="true" [wordWrapEnabled]="isWordWrapEnabled"
                            [allowColumnResizing]="true" [columnResizingMode]="'widget'"
                            (onContentReady)="setActionColumnWidth($event)">

                            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
                            <dxo-header-filter [visible]="false"></dxo-header-filter>
                            <dxo-paging [pageSize]="10"></dxo-paging>
                             <dxo-pager [visible]="true" [allowedPageSizes]="[10, 25, 50, 100]" [displayMode]="displayMode"
                            [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
                            <dxo-sorting mode="multiple"></dxo-sorting>
                            <dxo-scrolling  mode="standard" showScrollbar="always" useNative="true"></dxo-scrolling>

                                <ng-container *ngFor="let column of intcmntsgridConfig; let i = index">
                                    <ng-container *ngIf="column.hide !== true">
                                        <ng-container *ngIf="column.link; else noLink">
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter" cellTemplate="cellTemplate"></dxi-column>
                                        </ng-container>
                                        <ng-template #noLink>
                                            <ng-container *ngIf="column.icon; else noIcon">
                                                <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                    [allowFiltering]="column.filter" cellTemplate="iconTemplate"></dxi-column>
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #noIcon>
                                            <ng-container *ngIf="column.dateFormat; else noDate">
                                                <dxi-column *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                                                    [dataField]="column.columnDef" [caption]="column.header"
                                                    [allowFiltering]="column.filter" [dataType]="'date'" format="MM/dd/yyyy">
                                                </dxi-column>
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #noDate>
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter">
                                            </dxi-column>
                                        </ng-template>
                                    </ng-container>
                                </ng-container>
                                <dxi-column *ngIf="isVisible || isActionVisible" caption="Actions" [width]="actionColumnWidth"
                                    [allowSorting]="false" cellTemplate="actionsTemplate"></dxi-column>

                                <div *dxTemplate="let data of 'actionsTemplate'" class="licenseactioncontainer">
                                    <button class="fa fa-edit action-icon-button" [disabled]="isViewMode"
                                        [ngStyle]="{ 'display': (isShowEdit === true) ? 'inline-block' : 'none' }" pTooltip="Edit"
                                        tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="onnotesEdit(data,'Edit Notes')">
                                        <span class="sr-only">Edit</span>
                                    </button>
                                    <button class="fa fa-eye action-icon-button" [disabled]="isViewMode"
                                        [ngStyle]="{ 'display': (isShowView === true) ? 'inline-block' : 'none' }" pTooltip="View"
                                        tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onView(data)">
                                        <span class="sr-only">View</span>
                                    </button>
                                    <button class="fa fa-trash ml-3 action-icon-button deletebtn" pTooltip="Delete"
                                        [disabled]="isViewMode" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                        (click)="onNoteDelete(data, noteDeleteModel)">
                                        <span class="sr-only">Delete</span>
                                    </button>
                                    <!-- <button class="fa fa-trash action-icon-button deletebtn"
                                            [ngStyle]="{ 'display': (isShowDelete === true) ? 'inline-block' : 'none' }"
                                            pTooltip="Delete" tooltipPosition="bottom" (click)="onLicRequirementDelete(data, deleteModel)">
                                            <span class="sr-only">Delete</span>
                                        </button> -->

                                </div>
                                <div *dxTemplate="let d of 'cellTemplate'">
                                    <span href="javascript:void(0)" *ngIf="d.value && d.value !== 'null'" class="link-data"
                                        (click)="getRouter(d)">{{
                                        d.value !== 'null' ? d.value : ''
                                        }}</span>
                                </div>
                                <ng-container>
                                    <div *dxTemplate="let d of 'cellTemplate'">
                                        <span *ngIf="d.value && d.value !== 'null'" #contentWrapper
                                            [innerHTML]="d.value | safeHtml">{{
                                            d.value !== 'null' ? d.value : ''
                                            }}</span>
                                    </div>
                                </ng-container>
                                <div *dxTemplate="let d of 'iconTemplate'">
                                    <em class="fa fa-book"></em>
                                </div>
                            </dx-data-grid>

                            </div>

                        </p-accordionTab>

                    </p-accordion>

                </form>
                <div class="generatelicensecontainer justify-content-end">
                    <button pButton type="button" *ngIf="analystrole" label="Save" icon="pi pi-check" class="p-mt-3"
                        [disabled]="isViewMode" (click)="addLicenseKindEndoDetails()">
                    </button>
                </div>

            </p-tabPanel>

            <!-- <p-tabPanel>
          <ng-template pTemplate="header">
    <div class="tab-header">
      <i class="pi pi-check-circle"></i>
      <span>Determination</span>
    </div>
  </ng-template>
          <p-accordion>
            <p-accordionTab [header]="'Add Decision'">
                <form [formGroup]="adddecisionForm" class="entry-form">

                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-3">
                            <label for="provision">Application Status</label>
                            <p-dropdown id="provision" [options]="applicationStatusData" [autoDisplayFirst]="false"
                                optionLabel="value" optionValue="key" placeholder="Select"
                                formControlName="applicationStatus" [filter]="true" [showClear]="true">
                            </p-dropdown>
                        </div>

                    </div>


                    <div class="p-mt-2 p-d-flex p-jc-end">


                        <button type="button" pButton label="Update Status" icon="pi pi-plus" class="p-button-success"
                            (click)="updateApplicationStatus()">
                        </button>
                    </div>


                </form>
            </p-accordionTab>

            <p-accordionTab [header]="'Decision History'">
                <dx-data-grid [dataSource]="decisionStatusHistoryData" [showBorders]="true" [columnAutoWidth]="true"
                    [searchPanel]="{ visible: false }" [filterRow]="{ visible: true }">

                    <dxi-column dataField="applicationStatus" caption="Application Status"></dxi-column>
                    <dxi-column dataField="updatedby" caption="Updated By"></dxi-column>
                    <dxi-column dataField="updateddate" caption="Date Updated" dataType="date" format="MM/dd/yyyy"></dxi-column>

                    <dxi-column caption="Action" type="buttons">
                        <dxi-button icon="eye"></dxi-button>
                        <dxi-button icon="edit"></dxi-button>
                        <dxi-button icon="trash" (click)="deleteRow($event.row.data.id)">
                        </dxi-button>
                    </dxi-column>

                </dx-data-grid>
            </p-accordionTab>

            <p-accordionTab *ngIf="showDnqCommunication" [header]="'DNQ Communication'">
                <p-editor formControlName="description" [style]="{ height: '300px' }">
                </p-editor>
            </p-accordionTab>

        </p-accordion>

    </p-tabPanel> -->
            <!-- ================= TAB 2: Future Form Placeholder ================= -->
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="tab-header" (click)="validateLB($event)">
                        <i class="pi pi-check-circle"></i>
                        <span>Determination</span>
                    </div>
                </ng-template>
                <form [formGroup]="adddecisionForm" class="entry-form">

                    <p-accordion class="custom-accordion" [activeIndex]="0">
                        <p-accordionTab [header]="'Add Decision'">
                            <div class="p-fluid p-formgrid p-grid licensegrid">
                                <div class="p-field p-col-12 p-md-12 mb-0">
                                    <label for="applicationStatus">Application Status
                                        <span class="requiredfield text-danger">*</span>
                                    </label>
                                    <p-dropdown inputId="applicationStatus" [options]="applicationStatusData"
                                        [autoDisplayFirst]="false" optionLabel="value" optionValue="key"
                                        placeholder="Select Application Status"
                                        (onChange)="appstatusOnChange($event.value)" formControlName="applicationStatus"
                                        [filter]="true" [showClear]="false">
                                            <ng-template let-item pTemplate="selectedItem">
                                                <span
                                                    class="dropdownselectedItem"
                                                    [pTooltip]="item.value"
                                                    tooltipPosition="top"
                                                    [showDelay]="300"
                                                    tooltipStyleClass="pcustom-tooltip">
                                                    {{ item.value }}
                                                </span>
                                            </ng-template>
                                    </p-dropdown>
                                    <small class="p-error" *ngIf="showAppstatuserrmsg">
                                        {{ errorMessages['M0125'] || 'Please select an application status.' }}
                                    </small>
                                </div>
                            </div>
                            <div class="p-d-flex p-jc-end responsive-submit-btn">

                                <button type="button" pButton label="Update Status" [disabled]="isViewMode" class="updatestatusbtn" 
                                    (click)="updateApplicationStatus()"></button>
                            </div>
                        </p-accordionTab>

                        <p-accordionTab [header]="'Decision History'">
                        <div class="deficiencynotes-table-container deficiencyhistory-table-container">
                            <dx-data-grid #dataGrid [dataSource]="decisionStatusHistoryData" [showBorders]="true"
                                [rowAlternationEnabled]="true" [columnAutoWidth]="true" [wordWrapEnabled]="isWordWrapEnabled"
                                [allowColumnResizing]="true" [columnResizingMode]="'widget'"
                                (onContentReady)="setActionColumnWidth($event)">

                                <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
                                <dxo-header-filter [visible]="false"></dxo-header-filter>
                                <dxo-paging [pageSize]="10"></dxo-paging>
                                 <dxo-pager [visible]="true" [allowedPageSizes]="[10, 25, 50, 100]" [displayMode]="displayMode"
                            [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
                                <dxo-sorting mode="multiple"></dxo-sorting>

                                <ng-container *ngFor="let column of statushistorygridConfig; let i = index">
                                    <ng-container *ngIf="column.hide !== true">
                                        <ng-container *ngIf="column.link; else noLink">
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter"
                                                cellTemplate="cellTemplate"></dxi-column>
                                        </ng-container>
                                        <ng-template #noLink>
                                            <ng-container *ngIf="column.icon; else noIcon">
                                                <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                    [allowFiltering]="column.filter"
                                                    cellTemplate="iconTemplate"></dxi-column>
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #noIcon>
                                            <ng-container *ngIf="column.dateFormat; else noDate">
                                                <dxi-column
                                                    *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                                                    [dataField]="column.columnDef" [caption]="column.header"
                                                    [allowFiltering]="column.filter" [dataType]="'date'"
                                                    format="MM/dd/yyyy">
                                                </dxi-column>
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #noDate>
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter">
                                            </dxi-column>
                                        </ng-template>
                                    </ng-container>
                                </ng-container>
                                <!-- <dxi-column *ngIf="isVisible || isActionVisible" caption="Actions" [width]="actionColumnWidth"
                            [allowSorting]="false" cellTemplate="actionsTemplate"></dxi-column>

                        <div *dxTemplate="let data of 'actionsTemplate'">
                            <button class="fa fa-edit mr-3"
                                [ngStyle]="{ 'display': (isShowEdit === true) ? 'inline-block' : 'none' }"
                                pTooltip="Edit" tooltipPosition="bottom" (click)="onLicRequirementEdit(data)">
                                <span class="sr-only">Edit</span>
                            </button>
                            <button class="fa fa-eye ml-1"
                                [ngStyle]="{ 'display': (isShowView === true) ? 'inline-block' : 'none' }"
                                pTooltip="View" tooltipPosition="bottom" (click)="onView(data)">
                                <span class="sr-only">View</span>
                            </button>
                            <button class="fa fa-trash ml-3"
                                [ngStyle]="{ 'display': (isShowDelete === true) ? 'inline-block' : 'none' }"
                                pTooltip="Delete" tooltipPosition="bottom" (click)="onLicRequirementDelete(data, deleteModel)">
                                <span class="sr-only">Delete</span>
                            </button>

                        </div> -->
                                <div *dxTemplate="let d of 'cellTemplate'">
                                    <span href="javascript:void(0)" *ngIf="d.value && d.value !== 'null'"
                                        class="link-data" (click)="getRouter(d)">{{
                                        d.value !== 'null' ? d.value : ''
                                        }}</span>
                                </div>
                                <ng-container>
                                    <div *dxTemplate="let d of 'cellTemplate'">
                                        <span *ngIf="d.value && d.value !== 'null'" #contentWrapper
                                            [innerHTML]="d.value | safeHtml">{{
                                            d.value !== 'null' ? d.value : ''
                                            }}</span>
                                    </div>
                                </ng-container>
                                <div *dxTemplate="let d of 'iconTemplate'">
                                    <em class="fa fa-book"></em>
                                </div>
                            </dx-data-grid>
                            </div>
                        </p-accordionTab>



                    </p-accordion>
                </form>
                <!-- <div class="generatelicensecontainer justify-content-end">
                    <button pButton type="button"
                        *ngIf="analystrole && showGenerateButton && application_type != 'Name Change'"
                        label="Generate License" icon="pi pi-check" class="p-mt-3" (click)="showDialog()">
                    </button>
                </div> -->

            </p-tabPanel>

        </p-tabView>

        <!-- Approve Resolution Modal -->
        <ng-template #approveResolutionModel let-modal>
            <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
                <h4 class="form-modal-title">Approve Resolution Request</h4>
                <button type="button" class="close" aria-label="Close" (click)="modalStatusClose()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="form-modal-body p-3">
                <p class="delete-content">Are you sure you want to mark <span class="font-weight-bold font-italic">{{ resolutionProvisionValue }}</span> as resolved?</p>
            </div>
            <div class="confirm-removal-footer">
                <button class="confirm-removal-btn-cancel" (click)="modalStatusClose()">Cancel</button>
                <button class="confirm-removal-btn-confirm" (click)="onConfirmApproveResolution()">Proceed</button>
            </div>
        </ng-template>

        <!-- Deny Resolution Modal -->
        <ng-template #denyResolutionModel let-modal>
            <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
                <h4 class="form-modal-title">Deny Resolution Request</h4>
                <button type="button" class="close" aria-label="Close" (click)="modalStatusClose()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="form-modal-body p-3">
                <p class="delete-content">Are you sure you want to deny the resolution of <span class="font-weight-bold font-italic">{{ resolutionProvisionValue }}</span>?</p>
            </div>
            <div class="confirm-removal-footer">
                <button class="confirm-removal-btn-cancel" (click)="modalStatusClose()">Cancel</button>
                <button class="confirm-removal-btn-confirm" (click)="onConfirmDenyResolution()">Proceed</button>
            </div>
        </ng-template>

        <!-- View Resolution Notes Modal -->
        <ng-template #viewResolutionNotesModel let-modal>
            <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
                <h4 class="form-modal-title">Resolution Notes</h4>
                <button type="button" class="close" aria-label="Close" (click)="modalStatusClose()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="form-modal-body p-3">
                <label class="mb-1">Please describe the updates you have made to address <span class="font-weight-bold font-italic">{{ resolutionProvisionValue }}</span>.</label>
                <div class="form-control mt-2 view-resolution-notes-box">{{ viewResolutionNotesText }}</div>
            </div>
            <div class="confirm-removal-footer">
                <button class="confirm-removal-btn-cancel" (click)="modalStatusClose()">Close</button>
            </div>
        </ng-template>

        <!-- Approve Resolution Request (Requirements) -->
        <ng-template #approveResolutionReqModel let-modal>
            <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
                <h4 class="form-modal-title">Approve Resolution Request</h4>
                <button type="button" class="close" aria-label="Close" (click)="modalStatusClose()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="form-modal-body p-3">
                <p class="delete-content">Are you sure you want to mark <span class="font-weight-bold font-italic">{{ resolutionProvisionValue }}</span> as resolved?</p>
            </div>
            <div class="confirm-removal-footer">
                <button class="confirm-removal-btn-cancel" (click)="modalStatusClose()">Cancel</button>
                <button class="confirm-removal-btn-confirm" (click)="onConfirmApproveResolutionReq()">Proceed</button>
            </div>
        </ng-template>

        <!-- Deny Resolution Request (Requirements) -->
        <ng-template #denyResolutionReqModel let-modal>
            <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
                <h4 class="form-modal-title">Deny Resolution Request</h4>
                <button type="button" class="close" aria-label="Close" (click)="modalStatusClose()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="form-modal-body p-3">
                <p class="delete-content">Are you sure you want to deny the resolution of <span class="font-weight-bold font-italic">{{ resolutionProvisionValue }}</span>?</p>
            </div>
            <div class="confirm-removal-footer">
                <button class="confirm-removal-btn-cancel" (click)="modalStatusClose()">Cancel</button>
                <button class="confirm-removal-btn-confirm" (click)="onConfirmDenyResolutionReq()">Proceed</button>
            </div>
        </ng-template>

        <!-- View Resolution Notes (Requirements) -->
        <ng-template #viewResolutionNotesReqModel let-modal>
            <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
                <h4 class="form-modal-title">Resolution Notes</h4>
                <button type="button" class="close" aria-label="Close" (click)="modalStatusClose()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="form-modal-body p-3">
                <label class="mb-1">Please describe the updates you have made to address <span class="font-weight-bold font-italic">{{ resolutionProvisionValue }}</span>.</label>
                <div class="form-control mt-2 view-resolution-notes-box">{{ viewResolutionNotesText }}</div>
            </div>
            <div class="confirm-removal-footer">
                <button class="confirm-removal-btn-cancel" (click)="modalStatusClose()">Close</button>
            </div>
        </ng-template>

        <div class="navigation-buttons" *ngIf="!hidePreviousNextButtons">
            <button class="btn btn-outline-secondary float-left" (click)="moveToPrevious()">
                <span class="fas fa-arrow-left"></span> Previous
            </button>
            <button class="btn btn-primary float-right" (click)="moveToNext()">Next
                <span class="fas fa-arrow-right"></span></button>
        </div>
    </div>
</div>


<p-dialog [header]="warningTitleLabel" [(visible)]="showModal" [modal]="true" [closable]="false"
    [style]="{ width: '50vw', maxWidth: '900px' }" [draggable]="false" [resizable]="false" appendTo="body"
    [baseZIndex]="11000" styleClass="warning-due-date-dialog">
        <ng-template pTemplate="header">
        <div class="d-flex justify-content-between align-items-center w-100">
            <h4 class="form-modal-title m-0">{{warningTitleLabel}}</h4>
            <button type="button" class="close" aria-label="Close" (click)="modalClose()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </ng-template>
    <p>
        The selected {{ warningDateFieldLabel }} differs from the system-calculated date based on business rules.
        You may continue if the selected date is correct.
    </p>

    <ng-template pTemplate="footer">
        <button pButton type="button" class="w-100" label="OK" (click)="modalClose()">
        </button>
    </ng-template>

</p-dialog>

<p-dialog [(visible)]="showLicensePopup" [modal]="true" [style]="{width: '60vw'}" [draggable]="false"
    styleClass="generatelicensedialog" [resizable]="false" header="License Preview">
    <div #licenseContent class="license-container">
        <!-- <h1 class="text-center statetitle">State of Nevada</h1>
        <h3 class="statesubtitle text-center">License for Educational Personnel</h3> -->
        <div class="doc-logo-container">
       <img src="https://nevadadocs.blob.core.windows.net/customuserflow/edu-logo.svg" alt="Company Logo"  class="logo" />
        </div>

        <div class="state-subcontent text-center">
            <p class="licensenumber">{{license_number}}</p>
            <p class="licensecertifies">This License Certifies that</p>
            <h2 class="licensename">{{educatorName}}</h2>
        </div>

        <p class="state-description">
            Has complied with the prescribed rules and regulations of the Commission on Professional Standards in
            Education and that
            the Superintendent of Public Instruction has granted this license which authorizes the holder to provide
            service in the
            schools of the State of Nevada in the following areas:
        </p>

        <h4 class="provisionstitle">License Details</h4>

        <p-table [value]="flattenedArray" styleClass="p-datatable-gridlines mb-4">
            <ng-template pTemplate="header">
                <tr class="bg-gray-100">
                    <th [style]="{'width': '22%'}">License</th>
                    <!-- <th>Grade Level</th> -->
                    <th [style]="{'width': '20%'}">Original Endorsement Issue Date</th>
                    <th [style]="{'width': '24%'}">Endorsements</th>
                    <th [style]="{'width': '17%'}">License Issue Date</th>
                    <th [style]="{'width': '17%'}">Expiration Date</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-detail>
                <tr>

                    <td>{{detail.licenseType}} - {{detail.licensekind}}</td>
                    <!-- <td>{{detail.grade}}</td> -->
                    <td> <span class="licenpreviewpop-uporiginaleffdat">{{detail.originalEffectiveDate | date}}</span> </td>
                    <td><span class="licenpreviewpop-upendros">{{detail.endorsement}}</span></td>
                    <td><span class="licenpreviewpop-upeffectdate">{{detail.effectiveDate | date}}</span></td>
                    <td><span class="licenpreviewpop-upexpiration">{{detail.expirationDate | date}}</span></td>
                </tr>
            </ng-template>
        </p-table>

        <ng-container *ngIf="licensekindendopop_descriptiondata?.length > 0">
        <h4 class="provisionstitle">Provisions to be satisfied</h4>
        <p-table [value]="licensekindendopop_descriptiondata" styleClass="p-datatable-gridlines mb-4">
            <ng-template pTemplate="header">
                <tr>
                    <th [style]="{'width': '28%'}">Provisions</th>
                    <th [style]="{'width': '23%'}"> License Kind/Endorsement</th>
                    <th [style]="{'width': '32%'}">Addtional Text</th>
                    <th [style]="{'width': '17%'}">Required Due Date</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-prov>
                <tr>
                    <td> <span style="width: 200px; display: block;">{{prov.provisionName}}</span></td>
                    <td>{{prov.kindOrEndoName}}</td>
                    <td style="text-align: justify;"><span class="addtextlicensepopup">{{prov.additionalText}}</span></td>
                    <td><span style="width: 100px; display: block;">{{prov.dueDate | date}}</span></td>
                </tr>
            </ng-template>
        </p-table>
        </ng-container>

        <ng-container *ngIf="licensereq_descriptiondata?.length > 0">
        <h4 class="provisionstitle">License Requirements</h4>
        <p-table [value]="licensereq_descriptiondata" styleClass="p-datatable-gridlines">
            <ng-template pTemplate="header">
                <tr>
                    <th [style]="{'width': '15%'}"> Category</th>
                    <th [style]="{'width': '20%'}"> Source </th>
                    <th colspan="2" [style]="{'width': '49%'}">License Requirement</th>
                    <th [style]="{'width': '16%'}">Required Due Date</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-req>
                <tr>
                    <td>{{ req.req_category }}</td>
                    <td><span class="licenpreviewpop-upreq_source">{{ req.req_source }}</span></td>
                    <td [style]="{'width': '15%'}"><span class="licenpreviewpop-upreq_name">{{req.req_name}}</span></td>
                    <td class="text-justify text-sm"><span class="licenpreviewpop-upreqdescrip">{{req.req_description}}</span></td>
                    <td><span class="licenpreviewpop-upduedate">{{req.due_date | date}}</span></td>
                </tr>
            </ng-template>
        </p-table>
        </ng-container>
        <div class="licensepreviewactionbtns">
  <button pButton type="button" icon="pi pi-download" label="Publish"
    class="p-button-primary"
    (click)="modalStatusConfirm('publish')">
  </button>
  <span class="licensepreviewactionDiv"></span>
  <button pButton type="button" label="Cancel"
    class="p-button-primary cancel-btn"
    (click)="showLicensePopup = false">
  </button>
  <!-- <button pButton type="button" label="Confirm"
    class="p-button-primary"
    (click)="modalStatusConfirm()">
  </button> -->
</div>
    </div>
</p-dialog>

<p-dialog [(visible)]="showStatusModal" [modal]="true" [closable]="false"
    [style]="{ width: '400px' }" styleClass="update-intake-pending-dialog" [draggable]="false">
    <ng-template pTemplate="header">
        <div class="d-flex justify-content-between align-items-center w-100">
            <h4 class="form-modal-title m-0">Confirm Status Update</h4>
            <button type="button" class="close" aria-label="Close" (click)="cancelIntakePendingStatus()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </ng-template>
    <p>
        Are you sure you want to update the Application Status to <b>{{ statusval}}</b>?
    </p>

    <ng-template pTemplate="footer">
        <button pButton type="button" class="btn btn-outline-secondary" label="Cancel"
            (click)="modalStatusConfirmClose()"></button>
        <button pButton type="button" class="btn btn-primary mr-0" label="Confirm" (click)="modalStatusConfirm('confirm')"></button>
    </ng-template>

</p-dialog>

<p-dialog [(visible)]="showDNQPopup" [modal]="true" [style]="{width: '60vw'}" [draggable]="false" [resizable]="false"
    header="DNQ Preview" styleClass="dnqpreviewdialog">
    <div #dnqContent class="license-container">
        <!-- <h1 class="text-center statetitle">State of Nevada</h1>
        <h3 class="statesubtitle text-center">License for Educational Personnel</h3> -->
        <div class="previewimageconatiner" style="margin-top:15px;">
              <img class="dnqpreviewimage" src="../../assets/images/neveda-images/edu-logo.svg" alt="Logo" />
        </div>
        <p class="dnqcontent">{{currentDate}}</p>
        <p class="dnqcontent">Dear {{educatorName}},</p>
        <p class="dnqcontent">Your application has been evaluated and does not meet the requirements. You must meet the
            requirements below for your application to be approved. Please note that if any additional documents are required,
            they should be uploaded in your portal. For information on submitting official transcript(s), please visit our
          <a href="{{transcriptInfoUrl}}" target="_blank" style="color:#005A9C; text-decoration:none;">website</a>.
        </p>
        <!-- <p class="dnqcontent"><strong>Application Number:</strong> {{applicationNumber}}</p> -->
         <h6 class="font-weight-bold"> DNQ Communication - External </h6>
        <div class="dnqDescriptioncontent" id="dnqDescription" [innerHTML]="dnqText"></div>
        <p>
            Your application will remain valid for thirty (30) days from the date of the first notice of denial. If you do not
            provide the required information within the thirty (30) days, you will need to submit a new application. This will
            include a new set of fingerprints and new application fee if both were required for your application.
        </p>
        <p class="footer-signature">Thank you,
            <span style="margin-top:7px; display:block;">{{ analystName }} </span>
            <span style="display:block;">Office of Educator
                Licensure </span>
            Nevada Department of Education
        </p>
        <!-- <pre style="
        white-space: pre-wrap;
        font-family: inherit;
        margin: 0;
        padding: 8px;">
    {{ dnqText }}
  </pre> -->

        <!-- <hr /> -->
         <div class="w-100 text-center">
            <button pButton type="button" label="Save" icon="pi pi-save" (click)="downloadDNQ()">
            </button>
         </div>
    </div>
</p-dialog>

<p-dialog [header]="dialogHeader" [(visible)]="showdefcmntsEditPopup" [modal]="true" [closable]="false"
    [style]="{ width: '400px' }" (onShow)="onDialogShow()"  styleClass="custom-def-dialog">


    <div class="p-fluid">
        <div class="field">
            <label for="defcomments" class="block mb-2">
                <strong>
                    External Deficiency Comments <span style="color: red;">*</span>
                </strong>
            </label>
            <p-editor id="defcomments" [(ngModel)]="rowdnqcomments" placeholder="Enter External Deficiency Comments"
                [style]="{ height: '300px' }" styleClass="custom-editor"
                [ngClass]="{'ng-invalid ng-dirty': deficiencyCommentSubmitted && !isDefCommentValid()}">
            </p-editor>
            <small class="p-error" *ngIf="deficiencyCommentSubmitted && !isDefCommentValid()">
                {{ errorMessages['M0134'] || 'External Deficiency Comments are required to preview.' }}
            </small>
        </div>
    </div>



    <ng-template pTemplate="footer">
          <div class="custom-dialog-footer">
        <button pButton type="button" class="btn-cancel" label="Cancel" (click)="modaldefcmntsClose()">
        </button>

        <button pButton type="button" label="Save" class="mr-0" (click)="saveDefComments()">
        </button>
        </div>
    </ng-template>

</p-dialog>


<p-dialog [header]="dialogHeader" [(visible)]="showintcmtsEditPopup" [modal]="true" [closable]="false"
    [style]="{ width: '400px' }" (onShow)="onDialogShow()" styleClass="custom-edit-def-dialog">


    <div class="p-fluid">
        <div class="field">
            <label for="defcomments" class="block mb-2">
                <strong>
                    Notes <span style="color: red;">*</span>
                </strong>
            </label>
            <p-editor id="defcomments" [(ngModel)]="rowdnqcomments" placeholder="Enter Notes"
                [style]="{ height: '300px' }" styleClass="custom-editor"
                [ngClass]="{'ng-invalid ng-dirty': deficiencyCommentSubmitted && !isDefCommentValid()}">
            </p-editor>
            <small class="p-error" *ngIf="deficiencyCommentSubmitted && !isDefCommentValid()">
                <!-- {{ errorMessages['M0134'] || 'Notes are required to preview.' }} -->
                  Notes are required to preview.
            </small>
        </div>
    </div>



    <ng-template pTemplate="footer">
        <button pButton type="button" class="btn-cancel" label="Cancel" (click)="modaldefcmntsClose()">
        </button>

        <button pButton type="button" label="Save" (click)="saveDefComments()">
        </button>
    </ng-template>

</p-dialog>

<p-dialog header="Deficiency Communication Preview" [(visible)]="showdefNotesPreview" [modal]="true"
    [style]="{width: '600px'}" [draggable]="false" styleClass="generateDeficiencydialog">
    <!-- <h1 class="text-center statetitle">State of Nevada</h1>
    <h3 class="statesubtitle text-center">License for Educational Personnel</h3> -->
    <div class="previewimageconatiner">
              <img class="previewimage" src="../../assets/images/neveda-images/edu-logo.svg" alt="Logo" />
    </div>
    <table class="section-notes-table" style="width: 100%; border-collapse: collapse;">
        <thead>
            <tr style="background-color: #d9e7f7;">
            </tr>
        </thead>
        <tbody>
            <!-- <pre style="
        white-space: pre-wrap;
        font-family: inherit;
        margin: 0;
        padding: 8px; font-size: 16px;">
    {{ defcmntpopupdata }}
  </pre> -->
            <div class="preview-wrapper">
                <!-- <div *ngFor="let tab of groupedPreviewData | keyvalue">

                    <div class="tab-title">{{ tab.key }}</div>

                    <div *ngFor="let item of tab.value" class="item-block">
                        <div class="def-type">{{ item.deficiency_type }}</div>
                        <div class="note-text">{{ item.note_text }}</div>
                    </div>

                </div> -->
                <div [innerHTML]="defHeaderContent"></div>
                  <div *ngFor="let tab of tabNamesOrder" style="margin-bottom:16px">
                        <div *ngIf="groupedPreviewData[tab]">
                            <div class="tab-title">{{ tab }}</div>

                            <div *ngFor="let item of groupedPreviewData[tab]" class="item-block">
                            <div class="def-type">{{ item.deficiency_type }}</div>
                            <div class="note-text" [innerHTML]="item.note_text" ></div>
                            </div>
                        </div>
                 </div>
                 <div [innerHTML]="defFooterContent"></div>

            </div>

        </tbody>
    </table>
    <ng-template pTemplate="footer">
        <button pButton type="button" label="Publish & Update Status" (click)="downloadDeficiency()">
        </button>
    </ng-template>
</p-dialog>

<!-- <p-dialog header="Delete Record" [(visible)]="showdeleteModal" [modal]="true" [closable]="false"
    [style]="{ width: '400px' }">

    <p>
        Are you sure you want to delete?
    </p>

    <ng-template pTemplate="footer">
        <button pButton type="button" class="p-button-secondary" label="Reset" (click)="modalStatusClose()"></button>
        <button pButton type="button" label="Update" (click)="deleteRow()"></button>
    </ng-template>

</p-dialog> -->

<ng-template #deleteModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Delete Record</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <p class="delete-content">Are you sure you want to delete this record?
            This action cannot be undone.</p>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn  btn-md px-3 py-1" (click)="modalStatusClose()">Cancel</button>
            <button lang="en" class="btn  btn-md deletebtn " (click)="deleteRow()" ref="button">Delete</button>
        </div>
    </div>
</ng-template>

<ng-template #editModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Edit Record</h4>
        <button type="button" class="close" aria-label="Close" (click)="modalStatusClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <form [formGroup]="editprolickindForm" class="entry-form">

            <div class="p-fluid p-formgrid p-grid licensegrid provisiongrid">

                <!-- Category (read-only) -->
                <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                    <label>Category</label>
                    <input type="text" class="form-control" value="License" readonly />
                </div>

                <!-- Source / License Kind -->
                <div class="p-field p-col-12 p-md-3 w-100 provisionlabelinput">
                    <label for="licenseKind">Source <span class="requiredfield text-danger">*</span></label>
                    <p-multiSelect placeholder="Select License Kind" optionLabel="value" optionValue="key"
                        [filter]="true" filterBy="value" [showClear]="true" formControlName="provlickind"
                        [closeOnSelect]="false" display="chip" [options]="sortedLicenseKindData" styleClass="sourcedropdownchoice endorsement-Provision-pdropdown">
                    </p-multiSelect>
                    <div *ngIf="editprolickindForm.get('provlickind')?.touched && editprolickindForm.get('provlickind')?.errors as errors"
                        class="text-danger mt-1 err-font error-msg-text">
                        <span *ngIf="errors['required']">Source is required.</span>
                    </div>
                </div>

                <!-- Provision -->
                <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                    <label for="provision">Provision <span class="requiredfield text-danger">*</span></label>
                    <p-dropdown id="provision" [options]="lickindProvTypedataCopy" [autoDisplayFirst]="false"
                        optionLabel="value" optionValue="key" placeholder="Select"
                        (onChange)="editProlickindprovisionOnChange($event.value)" formControlName="lickindprovision"
                        [filter]="true" [showClear]="false" (onClear)="onlickindprovisionDropdownClear()" styleClass="provision-fixed-dropdown"
                        [pTooltip]="getLickindProvisionLabel()" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip">
                    </p-dropdown>
                    <div *ngIf="editprolickindForm.get('lickindprovision')?.touched && editprolickindForm.get('lickindprovision')?.errors as errors"
                        class="text-danger mt-1 err-font error-msg-text">
                        <span *ngIf="errors['required']">Provision is required.</span>
                    </div>
                </div>


                <!-- Due Date -->
                <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                    <label for="dueDate">Due Date <span class="requiredfield text-danger">*</span></label>
                    <!-- <p-calendar id="dueDate" formControlName="provdueDate" dateFormat="mm/dd/yy" [minDate]="today"
                        (onSelect)="onProvDueDateChange($event, null, 'editprolickind')"
                        (onInput)="formatDateInput($event)" [showIcon]="true" placeholder="MM/DD/YYYY">
                    </p-calendar> -->
                    <div class="input-group ssn-input-group">
                        <input type="text" id="provdueDateInput" formControlName="provdueDate" placeholder="MM/DD/YYYY"
                            data-placeholder="MM/DD/YYYY" class="form-control date-uppercase mt-1" maxlength="10"
                            (onSelect)="onProvDueDateChange($event, null, 'editprolickind')"
                            (blur)="onProvDueDateChange(editprolickindForm.get('provdueDate')?.value, null, 'editprolickind')"
                            (input)="formatDateInput($event, editprolickindForm.get('provdueDate'))" />
                        <span class="ssn-eye">
                            <button type="button" class="btn p-0 eye" 
                                (click)="openDatePickerForControl($event, editprolickindForm.get('provdueDate'), 'provdueDateInput', undefined, 'editprolickind')"
                                (keypress)="openDatePickerForControl($event, editprolickindForm.get('provdueDate'), 'provdueDateInput', undefined, 'editprolickind')"
                                title="Open Calendar" aria-label="Open date picker">
                                <span class="material-symbols-outlined f-20 cal">
                                    calendar_month
                                </span>
                            </button>
                        </span>
                    </div>
                    <div *ngIf="editprolickindForm.get('provdueDate')?.touched && editprolickindForm.get('provdueDate')?.errors as errors"
                        class="text-danger mt-1 err-font error-msg-text">
                        <span *ngIf="errors['required']">Due Date is required.</span>
                        <span *ngIf="errors['invalidDateFormat'] || errors['invalidDate']">
                            Enter a valid date in MM/DD/YYYY format.
                        </span>
                        <span *ngIf="errors['invalidYear']">Enter year between 1900 and 2100.</span>
                    </div>
                    <div id="dob-error"
                        *ngIf="editprolickindForm.get('provdueDate')?.touched && editprolickindForm.get('provdueDate')?.errors?.['pastDateNotAllowed']"
                        class="text-danger mt-1 err-font error-msg-text">
                        Date cannot be in the past.
                    </div>

                </div>

                <!-- Additional Text -->
                <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                    <label for="additionalText">Additional Text</label>
                    <textarea rows="3" cols="30" pInputTextarea maxlength="500" formControlName="provlickindaddText"
                        placeholder="Additional Text" class="popup-autoheighttextarea"></textarea>
                </div>
                <!-- <div *ngIf="editprolickindForm.get('provlickindaddText')?.touched && editprolickindForm.get('provlickindaddText')?.errors as errors"
                    class="text-danger mt-1 err-font">
                    <span *ngIf="errors['required']">Additional Text is required.</span>
                </div> -->

            </div>

        </form>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn  btn-md px-3 py-1" (click)="resetLicenseKindProvision()">Reset</button>
            <button lang="en" class="btn btn-primary btn-md rounded " (click)="updateLicenseProvision()"
                ref="button">Update</button>
        </div>
    </div>
</ng-template>

<ng-template #editModel1 let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Edit Record</h4>
        <button type="button" class="close" aria-label="Close" (click)="modalStatusClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <form [formGroup]="editprolicendoForm" class="entry-form">

            <div class="p-fluid p-formgrid p-grid provisionscontainer provisiongrid">

                <!-- Category (read-only) -->
                <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                    <label>Category</label>
                    <input type="text" class="form-control" value="Endorsement" readonly />
                </div>

                <!-- Source / Endorsement -->
                <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                    <label for="licenseKind">Source <span class="requiredfield text-danger">*</span></label>
                    <p-multiSelect [options]="endorsementProvisionData" placeholder="Select Endorsement"
                        optionLabel="value" optionValue="key" [filter]="true" filterBy="value" [showClear]="true"
                        formControlName="provendorsement" [closeOnSelect]="false" display="chip" [appendTo]="'body'" 
                        styleClass="sourcedropdownchoice endorsement-Provision-pdropdown" (onChange)="onEditEndoExpdateGet($event,editprolicendoForm.get('provendorsement'))" 
                         (onClear)="onEditEndoExpdateGet($event,editprolicendoForm.get('provendorsement'))">
                    </p-multiSelect>
                    <div *ngIf="editprolicendoForm.get('provendorsement')?.touched && editprolicendoForm.get('provendorsement')?.errors as errors"
                        class="text-danger mt-1 err-font error-msg-text">
                        <span *ngIf="errors['required']">Source is required.</span>
                    </div>
                </div>

                <!-- Provision -->
                <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                    <label for="provision">Provision <span class="requiredfield text-danger">*</span></label>
                    <p-dropdown id="provision" [options]="licendoProvTypedataCopy" [autoDisplayFirst]="false"
                        optionLabel="value" optionValue="key" placeholder="Select" formControlName="endoprovision"
                        [filter]="true" [showClear]="false" styleClass="provision-fixed-dropdown"
                        [pTooltip]="getProvisionLabel()" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip">
                    </p-dropdown>
                    <div *ngIf="editprolicendoForm.get('endoprovision')?.touched && editprolicendoForm.get('endoprovision')?.errors as errors"
                        class="text-danger mt-1 err-font error-msg-text">
                        <span *ngIf="errors['required']">Provision is required.</span>
                    </div>
                </div>

                <!-- Due Date -->
                <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                    <label for="dueDate">Due Date <span class="requiredfield text-danger">*</span></label>
                    <!-- <p-calendar id="dueDate" formControlName="endodueDate" dateFormat="mm/dd/yy" [minDate]="today"
                        (onSelect)="onProvDueDateChange($event, null, 'editprolicendo')" [showIcon]="true"
                        placeholder="MM/DD/YYYY">
                    </p-calendar> -->

                    <div class="input-group ssn-input-group">
                        <input type="text" id="endodueDateInput" formControlName="endodueDate" placeholder="MM/DD/YYYY"
                            data-placeholder="MM/DD/YYYY" class="form-control date-uppercase mt-1" maxlength="10"
                            (onSelect)="onProvDueDateChange($event, null, 'editprolicendo')"
                            (blur)="onProvDueDateChange(editprolicendoForm.get('endodueDate')?.value, null, 'editprolicendo')"
                            (input)="formatDateInput($event, editprolicendoForm.get('endodueDate'))" />
                        <span class="ssn-eye">
                            <button type="button" class="btn p-0 eye" 
                                (click)="openDatePickerForControl($event, editprolicendoForm.get('endodueDate'), 'endodueDateInput', undefined, 'editprolicendo')"
                                (keypress)="openDatePickerForControl($event, editprolicendoForm.get('endodueDate'), 'endodueDateInput', undefined, 'editprolicendo')"
                                title="Open Calendar" aria-label="Open date picker">
                                <span class="material-symbols-outlined f-20 cal">
                                    calendar_month
                                </span>
                            </button>
                        </span>
                    </div>
                    <div *ngIf="editprolicendoForm.get('endodueDate')?.touched && editprolicendoForm.get('endodueDate')?.errors as errors"
                        class="text-danger mt-1 err-font error-msg-text">
                        <span *ngIf="errors['required']">Due Date is required.</span>
                        <span *ngIf="errors['invalidDateFormat'] || errors['invalidDate']">
                            Enter a valid date in MM/DD/YYYY format.
                        </span>
                        <span *ngIf="errors['invalidYear']">Enter year between 1900 and 2100.</span>
                    </div>
                    <div id="dob-error"
                        *ngIf="editprolicendoForm.get('endodueDate')?.touched && editprolicendoForm.get('endodueDate')?.errors?.['pastDateNotAllowed']"
                        class="text-danger mt-1 err-font error-msg-text">
                        Date cannot be in the past.
                    </div>

                </div>

                <!-- Additional Text -->
                <div class="p-field p-col-12 p-md-3 mb-0 w-100 provisionlabelinput">
                    <label for="additionalText">Additional Text</label>
                    <textarea rows="3" cols="30" pInputTextarea maxlength="500" formControlName="endoadditionalText"
                        placeholder="Additional Text" class="popup-autoheighttextarea"></textarea>
                </div>

            </div>
        </form>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn btn-md px-3 py-1" (click)="resetLicenseEndoProvision()">Reset</button>
            <button lang="en" class="btn btn-md btn-primary rounded" (click)="updateEndorsementProvision()"
                ref="button">Update</button>
        </div>
    </div>
</ng-template>

<ng-template #deleteModel1 let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Delete Record</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <p class="delete-content">Are you sure you want to delete this record?
            This action cannot be undone.</p>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn  btn-md px-3 py-1" (click)="modalStatusClose()">Cancel</button>
            <button lang="en" class="btn  btn-md deletebtn " (click)="onLicRequirementDelete()"
                ref="button">Delete</button>
        </div>
    </div>
</ng-template>

<ng-template #editModel2 let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Edit Record</h4>
        <button type="button" class="close" aria-label="Close" (click)="modalStatusClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <form [formGroup]="editprolicreqForm" class="entry-form">

            <div class="provisionscontainer provisiongrid">
                <div class="mb-0 w-100 provisionlabelinput">
                    <label for="type">Category
                        <span class="requiredfield text-danger">*</span>
                    </label>

                    <p-dropdown id="type" [options]="typeOptions" optionLabel="value" optionValue="key"
                        placeholder="Select" formControlName="type" [autoDisplayFirst]="false" [showClear]="false" styleClass="provision-fixed-dropdown w-100">
                                            <ng-template let-item pTemplate="selectedItem">
                                                <span
                                                    class="dropdownselectedItem"
                                                    [pTooltip]="item.value"
                                                    tooltipPosition="top"
                                                    [showDelay]="300"
                                                    tooltipStyleClass="pcustom-tooltip">
                                                    {{ item.value }}
                                                </span>
                                            </ng-template>
                    </p-dropdown>
                     <div *ngIf="editprolicreqForm.get('type')?.touched
                                                                            && editprolicreqForm.get('type')?.errors?.['required']"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            Category is required.
                                        </div>
                </div>

                <!-- Source Dropdown -->
                <div class="mb-0 w-100 provisionlabelinput">
                    <label for="source">Source
                        <span class="requiredfield text-danger">*</span>
                    </label>

                      <p-multiSelect placeholder="Select Source" optionLabel="value" optionValue="key"
                                            [filter]="true" filterBy="value" [showClear]="true" formControlName="source"
                                            [closeOnSelect]="false" display="chip"
                                            [disabled]="!editprolicreqForm.get('type')?.value" [options]="editSourceOptions"
                                             styleClass="sourcedropdownchoice endorsement-Provision-pdropdown"
                                            (onChange)="onEditSourceChange($event)"
                                            (onClear)="onEditSourceChange($event)">
                                        </p-multiSelect>
                                            <div *ngIf="editprolicreqForm.get('source')?.touched && editprolicreqForm.get('source')?.errors as errors"
                                                class="text-danger mt-1 err-font error-msg-text">
                                                <span *ngIf="errors['required']">source is required.</span>
                                            </div>

                </div>
                <!-- Provision Dropdown -->
                <div class="mb-0 w-100 provisionlabelinput">
                    <label for="provision">Requirement<span class="requiredfield text-danger">*</span></label>
                    <p-dropdown id="provision" [options]="licrequirementsData" [autoDisplayFirst]="false" required
                        optionLabel="value" optionValue="key" placeholder="Select" formControlName="licrequirement"
                        [filter]="true" [showClear]="false" styleClass="provision-fixed-dropdown w-100">
                    </p-dropdown>
                      <div *ngIf="editprolicreqForm.get('licrequirement')?.touched && editprolicreqForm.get('licrequirement')?.errors as errors"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            <span *ngIf="errors['required']">Requirement is required.</span>
                                        </div>
                </div>
                <div class="mb-0 w-100 provisionlabelinput">
                    <div class="form-group">
                        <label for="input_registration_form_date_of_birth">Due Date<span
                                class="requiredfield text-danger">*</span></label>
                        <div class="input-group ssn-input-group">
                            <input type="text" id="reqdueDateInput" formControlName="reqdueDate"
                                placeholder="Select Due Date" data-placeholder="MM/DD/YYYY"
                                class="form-control date-uppercase mt-1" required aria-required="true"
                                maxlength="10" (onSelect)="onProvDueDateChange($event, null, 'prolicreq')"
                                (blur)="onProvDueDateChange(editprolicreqForm.get('reqdueDate')?.value, null, 'prolicreq')"
                                (input)="formatDateInput($event, editprolicreqForm.get('reqdueDate'))" />

                            <span class="ssn-eye" [ngClass]="{
                                'ssn-eye-error-position':
                                  editprolicreqForm.get('reqdueDate')?.touched &&
                                  editprolicreqForm.get('reqdueDate')?.errors
                              }">
                                <button type="button" id="btn_registration_form_open_calendar" class="btn p-0 eye"
                                    (click)="openDatePickerForControl($event, editprolicreqForm.get('reqdueDate'), 'reqdueDateInput', undefined, 'prolicreq')"
                                    (keypress)="openDatePickerForControl($event, editprolicreqForm.get('reqdueDate'), 'reqdueDateInput', undefined, 'prolicreq')"
                                    title="Open Calendar" aria-label="Open date picker">
                                    <span class="material-symbols-outlined f-20 cal">
                                        calendar_month
                                    </span>
                                </button>
                            </span>

                            <div *ngIf="editprolicreqForm.get('reqdueDate')?.touched && editprolicreqForm.get('reqdueDate')?.errors as errors"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            <span *ngIf="errors['required']">Due Date is required.</span>
                                            <span *ngIf="errors['invalidDateFormat'] || errors['invalidDate']">
                                                Enter a valid date in MM/DD/YYYY format.
                                            </span>
                                            <span *ngIf="errors['invalidYear']">Enter year between 1900 and 2100.</span>
                                        </div>
                                        <div id="dob-error"
                                            *ngIf="editprolicreqForm.get('reqdueDate')?.touched && editprolicreqForm.get('reqdueDate')?.errors?.['pastDateNotAllowed']"
                                            class="text-danger mt-1 err-font error-msg-text">
                                            Date cannot be in the past.
                                        </div>

                        </div>
                    </div>
                </div>
            </div>

        </form>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn btn-md px-3 py-1" (click)="resetLicenseRequirementsPopup()">Reset</button>
            <button lang="en" class="btn btn-md btn-primary rounded" (click)="updateLicenseRequirements()"
                ref="button">Update</button>
        </div>
    </div>
</ng-template>


<ng-template #noteDeleteModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Delete Note</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <p class="delete-content">Are you sure you want to delete this record?
            This action cannot be undone.</p>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn btn-primary btn-md px-3 py-1" (click)="closePopup()">Cancel</button>
            <button lang="en" class="btn btn-primary btn-md deletebtn " (click)="onDeleteItem()"
                ref="button">Delete</button>
        </div>
    </div>
</ng-template>

<p-dialog [(visible)]="showIntakePendingModal" [modal]="true" [closable]="false"  [draggable]="false"
    [style]="{ width: '450px' }" styleClass="update-intake-pending-dialog">

    <ng-template pTemplate="header">
        <div class="d-flex justify-content-between align-items-center w-100">
            <h4 class="form-modal-title m-0">Confirm Status Change</h4>
            <button type="button" class="close" aria-label="Close" (click)="cancelIntakePendingStatus()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </ng-template>

    <p>Are you sure you want to update the Application Status to <b>{{ statusval}}</b>?</p>
    <p>
      <strong>Warning: </strong>  All previous validations will be cleared, and the application will have to be reviewed again. Do you wish to continue?
    </p>

    <ng-template pTemplate="footer">
        <button pButton  type="button" class="btn btn-outline-secondary" label="Cancel"
            (click)="cancelIntakePendingStatus()"></button>
        <button pButton type="button" class="btn btn-primary mr-0" label="confirm" (click)="proceedIntakePendingStatus()"></button>
    </ng-template>

</p-dialog>
